const { default: Axios, default: axios } = require('axios');
const { countBy, each, unset } = require('lodash');

require('./bootstrap');
// require('./pages/composition');

require('./pages/email.js');
require('./pages/proposal.js');
require('./pages/synthesis.js');
require('./pages/chat.js');
require('./pages/wizard-1.js');

require('./pages/checklist.js');

import Teto from './clients/Teto.js';
import Estancorp from './clients/estancorp.js';
import Chats from './components/Chats.js';
import Chat from './pages/chat.js';
// import ChatsV3 from './components/Chatsv3.js';
import GeoLocation from './components/GeoLocation.js';
import Datepicker from './components/Datepicket.js';
import ExportData from './components/ExportData.js';
import LinkChecker from './components/LinkChecker.js';
import Loader from './components/Loader.js';
import Notification from './components/Notification.js';
import SicknessWizard from './components/SicknessWizard.js';
import utilities from './components/utilities.js';
import { error, fn } from 'jquery';
import Opportunity from './pages/Opportunity.js';
// import { createElement } from 'dropzone';
import moment from 'moment';
import ProductSort from './components/ProductSort.js';
import Lia from './components/Lia.js';
import RepeaterList from './components/RepeaterList.js';
import GroupRepeaterList from './components/GroupRepeaterList.js';

const classUtilitites = new utilities;

Estancorp.init();
Teto.init();
Opportunity.init();
ProductSort.init();
RepeaterList.init();
GroupRepeaterList.init();


// require('./pages/dashboard.js');

$(document).ready(function () {
    render();
});

function elCustomToggle() {
    let elm = $(this);
    let elmTarget = elm.attr('data-target');
    let classToggle = elm.attr('data-target-classtoggle');
    $(elmTarget).toggleClass(classToggle);
}

function changeFormNationality() {
    var person = $('input[name="person"]:checked').val() == 1 ? 'personal' : 'enterprise';

    $('.enterprise').addClass('hide');
    $('.personal').addClass('hide');
    $('.international').addClass('hide');
    $('.nacional').addClass('hide');

    switch ($(this).val()) {
        case 'nacional':
            $('.nacional.' + person.toLowerCase()).removeClass('hide');
            break;
        case 'international':
            $('.international.' + person.toLowerCase()).removeClass('hide');
            break;
    }
}

function changeFormEnterprise() {
    if ($('input[name="origin"]').attr('type') == 'hidden') {
        var origin = $('input[name="origin"]').val() == 'nacional' ? 'nacional' : 'international';
    } else {
        var origin = $('input[name="origin"]:checked').val() == 'nacional' ? 'nacional' : 'international';
    }

    $('.enterprise').addClass('hide');
    $('.personal').addClass('hide');
    $('.international').addClass('hide');
    $('.nacional').addClass('hide');

    switch ($(this).val()) {
        case '1':
            $('.personal.' + origin.toLowerCase()).removeClass('hide');
            break;
        case '2':
            $('.enterprise.' + origin.toLowerCase()).removeClass('hide');
            break;
    }
}


function ajaxFunction(e, element = "") {

    if (element == "") {
        var element = $(this);
    }
    var url_ajax = element.data("ajax");

    //if true, show modal confirm, else, only send
    if(element.hasClass('bt-ajax-send-file-chat'))
    {
        e.preventDefault();
        Swal.fire({
            title: "Deseja enviar este arquivo?",
            showDenyButton: true,
            showCancelButton: true,
            confirmButtonText: "Enviar",
            denyButtonText: `Cancelar`,
            footer: '<div style="display:flex; flex-flow:column; align-items:center;"><em>'+element.text()+'</em><br /><a href="'+element.attr('data-file')+'" target="_blank">Visualizar arquivo <i class="fas fa-external-link-alt"></i></a></div>'
          }).then((result) => {
            if (result.isConfirmed) {

                Loader.show();
                // $('html').css('overflow', 'hidden');

                element.attr('disabled', 'disabled');

                $.ajax({
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': CSRF_TOKEN
                    },
                    url: url_ajax,
                    data: $(this).data(),
                    dataType: "json",
                    success: function (data) {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        element.removeAttr('disabled');


                        classUtilitites.switchReturns(data, element);

                        classUtilitites.formSelects();

                        $('#myModal' + COUNT_MODAL).modal("hide");
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        element.removeAttr('disabled');

                        classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

                        if (APP_DEBUG != "ON") {
                            setTimeout(function () {
                                location.reload();
                            }, 1000);
                        }
                    }
                });

            } else if (result.isDenied) {
              Swal.fire("Ok, cancelado", "", "info");
            }
        });

    } else {

        Loader.show();
        // $('html').css('overflow', 'hidden');

        element.attr('disabled', 'disabled');

        var sendData = element.hasClass('bt-ajax-no-data') ? {} : element.data();

        if(element.val() != undefined) sendData.value_field = element.val();

        $.ajax({
            type: "POST",
            headers: {
                'X-CSRF-TOKEN': CSRF_TOKEN
            },
            url: url_ajax,
            data: sendData,
            dataType: "json",
            success: function (data) {
                // $('html').css('overflow', 'auto');
                Loader.hide();
                element.removeAttr('disabled');

                classUtilitites.switchReturns(data, element);

                classUtilitites.formSelects();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // $('html').css('overflow', 'auto');
                Loader.hide();
                element.removeAttr('disabled');

                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        });

        if (element.hasClass('update-data-page')) {
            let page = element.attr('data-page');
            page = parseInt(page) + 1;

            element.removeData("page");
            element.data("page", page);
            element.attr('data-page', page);
        };
    }

}


function checkElement() {

    var sendData = [];
    var element = $(this);
    var url_ajax = $(this).data("ajax");

    sendData.push(element.data);

    // $.ajax({
    //     type: "GET",
    //     headers: {
    //         'X-CSRF-TOKEN': CSRF_TOKEN
    //     },
    //     url: url_ajax,
    //     dataType: "json",
    //     data: {
    //         return_json: true
    //     },
    //     success: function (data) {
    //         var colspan = element.closest('tr').find('td').length;
    //         $('<tr id="edit_' + id + '"><td colspan="' + colspan + '"><div style="display: none;">' + data.result.html + '</div></td></tr>').insertAfter('#' + id);
    //         $('#edit_' + id).find('div:eq(0)').slideToggle('slow');
    //     },
    //     error: function (jqXHR, textStatus, errorThrown) {
    //         classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
    //         if (APP_DEBUG != "ON") {
    //             setTimeout(function () {
    //                 location.reload();
    //             }, 1000);
    //         }
    //     }
    // });
}

function addElement() {

    var element = $(this);
    var id = $(this).data('id');
    var url_ajax = $(this).data("ajax");

    Loader.show();
    // $('html').css('overflow', 'hidden');

    $.ajax({
        type: "GET",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: url_ajax,
        dataType: "json",
        data: {
            return_json: true
        },
        success: function (data) {
            // $('html').css('overflow', 'auto');
            Loader.hide();

            var colspan = element.closest('tr').find('td').length;
            $('<tr id="edit_' + id + '"><td colspan="' + colspan + '"><div style="display: none;">' + data.result.html + '</div></td></tr>').insertAfter('#' + id);
            $('#edit_' + id).find('div:eq(0)').slideToggle('slow');
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // $('html').css('overflow', 'auto');
            Loader.hide();

            classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });
}

function submitAjax() {

    var element = $(this);
    var form = $(this);

    var btnSubmit = element.find('button[type="submit"]');

    btnSubmit.attr('disabled', 'disabled').attr('data-val', btnSubmit.html()).html(btnSubmit.attr('data-wait'));

    Loader.show();
    // $('html').css('overflow', 'hidden');

    console.log();

    let formData,fileInput,blob;

    if($(form[0].userfile).length > 0){
        fileInput = document.getElementById('uploadFile');
        blob = fileInput.files[0];
        formData = new FormData(this);
        if (blob != undefined) {
            formData.append('userfile', blob);
        }
        formData.append('content', '.');
        formData.append('sendFile', true);
    }else{
        formData = form.serialize();
    }

    $.ajax({
        type: "POST",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: form.data('action'),
        data: formData,
        contentType: $(form[0].userfile).length > 0 ? false : "application/x-www-form-urlencoded; charset=UTF-8",
        processData: $(form[0].userfile).length > 0 ? false : true,
        dataType: "json",
        success: function (data) {
            btnSubmit.removeAttr('disabled').html(btnSubmit.attr('data-val'));

            if (data.error) {
                // $('html').css('overflow', 'auto');
                Loader.hide();

                classUtilitites.showAlert(data.message, "Ok", "error");
            } else {
                // $('html').css('overflow', 'auto');
                Loader.hide();
                classUtilitites.createOldForm();

                if (data.result.method != undefined) {
                    classUtilitites.switchReturns(data, element);
                } else {
                    classUtilitites.showAlert(data.message, "Ok", "success");

                        // detect modal in show
                        let modalOpened = $('.modal.show').attr('id');
                        if($(`#${modalOpened}`).length > 0){
                            $(`#${modalOpened}`).remove();
                            $(`.modal-backdrop`).remove();
                        }

                }
            }

        },
        error: function (jqXHR, textStatus, errorThrown) {
            btnSubmit.removeAttr('disabled').html(btnSubmit.attr('data-val'));
            // $('html').css('overflow', 'auto');
            Loader.hide();
            classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });

    return false;
}

// campos com a classe .confirm-on-submit pedem confirmação (label + de/para) antes do form ser enviado, só quando o valor muda
function initConfirmOnSubmit() {
    var confirmedForms = new WeakSet();
    var escapeHtml = function (text) {
        return $("<div>").text(text == null ? "" : text).html();
    };

    document.addEventListener("submit", function (e) {
        var form = e.target;
        if (!(form instanceof HTMLFormElement)) return;

        if (confirmedForms.has(form)) {
            confirmedForms.delete(form);
            return;
        }

        var changes = Array.prototype.reduce.call(form.querySelectorAll(".confirm-on-submit"), function (acc, field) {
            if (/_clone$/.test(field.id)) return acc;

            var oldText, newText;
            if (field.tagName === "SELECT") {
                var originalOption = field.querySelector("option[selected]");
                var oldValue = originalOption ? originalOption.value : "";
                if (field.value === oldValue) return acc;

                oldText = originalOption ? originalOption.text : "-";
                newText = field.selectedIndex >= 0 ? field.options[field.selectedIndex].text : field.value;
            } else {
                oldText = field.dataset.oldvalue !== undefined ? field.dataset.oldvalue : field.defaultValue;
                if (field.value === oldText) return acc;

                newText = field.value;
            }

            var labelEl = field.id ? document.querySelector('label[for="' + field.id + '"]') : null;
            var label = labelEl ? labelEl.textContent.replace(/\*\s*$/, "").trim() : (field.name || field.id);

            acc.push(
                escapeHtml(label) + ": <strong>" + escapeHtml(oldText || "-") + "</strong> &rarr; <strong>" +
                escapeHtml(newText || "-") + "</strong>"
            );
            return acc;
        }, []);
        if (!changes.length) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        Swal.fire({
            title: title_msg_alert,
            html: "Você está prestes a salvar as seguintes alterações:<br><br>" + changes.join("<br>"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: confirm_msg_alert,
            cancelButtonText: cancel_msg_alert,
            reverseButtons: true
        }).then(function (result) {
            if (result.value) {
                confirmedForms.add(form);
                form.requestSubmit ? form.requestSubmit() : $(form).trigger("submit");
            }
        });
    }, true);
}

function submitAjaxRecepcionista() {

    var element = $(this);
    var form = $(this);

    var btnSubmit = element.find('button[type="submit"]');

    btnSubmit.attr('disabled', 'disabled').attr('data-val', btnSubmit.html()).html(btnSubmit.attr('data-wait'));

    Loader.show();
    // $('html').css('overflow', 'hidden');

    $.ajax({
        type: "POST",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: form.data('action'),
        data: form.serialize(),
        dataType: "json",
        success: function (data) {
            btnSubmit.removeAttr('disabled').html(btnSubmit.attr('data-val'));

            if (data.error) {
                // $('html').css('overflow', 'auto');
                Loader.hide();

                classUtilitites.showAlert(data.message, "Ok", "error");
            } else {
                // $('html').css('overflow', 'auto');
                Loader.hide();

                if (data.result.method != undefined) {

                    //remove aba marcada
                        $(".wizard-step").attr("data-wizard-state","");
                    //ativa aba certa
                        $(".wizard-step[data-wizard-content=2]").attr("data-wizard-state","current");

                    // conteudo das abas
                        $(".wiz-custom-content-aba").attr('data-wizard-state', '');
                        $("#wiz-custom-content-aba-2").attr('data-wizard-state', 'current');

                        classUtilitites.switchReturns(data);

                } else {
                    classUtilitites.showAlert(data.message, "Ok", "success");
                }
            }

        },
        error: function (jqXHR, textStatus, errorThrown) {
            btnSubmit.removeAttr('disabled').html(btnSubmit.attr('data-val'));
            // $('html').css('overflow', 'auto');
            Loader.hide();
            classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });

    return false;
}

function submitAjaxRecepcionista2() {

    var element = $(this);
    var form = $(this);

    var btnSubmit = element.find('button[type="submit"]');

    btnSubmit.attr('disabled', 'disabled').attr('data-val', btnSubmit.html()).html(btnSubmit.attr('data-wait'));

    Loader.show();
    // $('html').css('overflow', 'hidden');

    $.ajax({
        type: "POST",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: form.data('action'),
        data: form.serialize(),
        dataType: "json",
        success: function (data) {
            btnSubmit.removeAttr('disabled').html(btnSubmit.attr('data-val'));

            if (data.error) {
                // $('html').css('overflow', 'auto');
                Loader.hide();

                classUtilitites.showAlert(data.message, "Ok", "error");
            } else {
                // $('html').css('overflow', 'auto');
                Loader.hide();

                if (data.result.method != undefined) {

                    $('#wiz-custom-content-aba-2').html("");

                    //remove aba marcada
                    $(".wizard-step[data-wizard-content=2]").attr("data-wizard-state","");
                    //ativa aba certa
                        $(".wizard-step[data-wizard-content=3]").attr("data-wizard-state","current");

                    // conteudo das abas
                        $(".wiz-custom-content-aba-2").attr('data-wizard-state', '');
                        $("#wiz-custom-content-aba-3").attr('data-wizard-state', 'current');

                        classUtilitites.switchReturns(data);

                } else {
                    classUtilitites.showAlert(data.message, "Ok", "success");
                }
            }

        },
        error: function (jqXHR, textStatus, errorThrown) {
            btnSubmit.removeAttr('disabled').html(btnSubmit.attr('data-val'));
            // $('html').css('overflow', 'auto');
            Loader.hide();
            classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });

    return false;
}

// function showWizardAba() {

//     var abaClass    = ".wizard-step";
//     var abaId       = $(this).attr("data-wizard-content");

//     if( $(this).hasClass("aba-disabled") ) return;

//     $(abaClass).attr("data-wizard-state", "");
//     $(this).attr("data-wizard-state", "current");

//     //contentAbaWizard
//     $(".wiz-custom-content-aba").attr("data-wizard-state", "");
//     $("#wiz-custom-content-aba-"+abaId).attr("data-wizard-state", "current")

// }

function checkIndication() {

    $(".wrap-is-or-not-broker").hide();
    $('input[name="radioCheckCorretor"]').prop('checked', false);

    if( $('input#sim-indicacao').prop('checked') ) {
        $(".wrap-is-or-not-indication[data-corretor=true]").show();
    } else {
        $(".wrap-is-or-not-indication").hide();
        $(".wrap-is-or-not-broker[data-corretor=true]").show();
    }

}

function checkIdCorretorInReception() {

    $(".wrap-is-or-not-broker").hide();

    if( $('input#sim-corretor').prop('checked') ) {
        $(".wrap-is-or-not-broker[data-corretor=true]").show();
    } else {
        $(".wrap-is-or-not-broker[data-corretor=false]").show();
    }

}

function checkRouletteBoolean() {

    var element = $('input[name=radioCheckRoleta]:checked');

    if(element.val() == 'true'){
        $(".roulette-boolean-true").show();
        $(".roulette-boolean-false").hide();
        $("#roullete_agent").prop('disabled', false);
        $("#user_id_responsible_agent").prop('disabled', true);
        $("#user_id_responsible").prop('disabled', false);
    }else{
        $(".roulette-boolean-false").show();
        $(".roulette-boolean-true").hide();
        $("#roullete_agent").prop('disabled', true);
        $("#user_id_responsible_agent").prop('disabled', false);
        $("#user_id_responsible").prop('disabled', true);
    }

}

function removeSelectedComposition() {
    var id_composition = $(this).attr('data-id');

    $('#ac-change-component-' + id_composition).show();
    $('#ac-selected-component-' + id_composition).hide();
    $('#ac-selected-component-' + id_composition).html('');

    classUtilitites.calculateComposition();
}

function confirmFunction() {

    var url_ajax = $(this).data("ajax");
    var message = $(this).data("message");
    const _this = $(this);
    if ($(this).data("target_id") != undefined) var target_id = $(this).data("target_id");

    Swal.fire({
        title: title_msg_alert,
        text: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: confirm_msg_alert,
        cancelButtonText: cancel_msg_alert,
        reverseButtons: true
    }).then(function (result) {
        if (result.value) {
            Loader.show();
            // $('html').css('overflow', 'hidden');

            $.ajax({
                type: "POST",
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
                url: url_ajax,
                data: {},
                dataType: "json",
                success: function (data) {

                    if (data.error) {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        classUtilitites.showAlert(data.message, "Ok", "error");
                    } else {

                        if(_this.attr('target') == '_blank'){
                            data = Object.assign(data, {newWindow: true});
                        }

                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        if (data.result.target != undefined) {
                            classUtilitites.switchReturns(data);
                        } else {
                            if (target_id != undefined) {
                                $('#' + target_id).remove();
                                $('.sub-' + target_id).remove();
                                classUtilitites.showAlert(data.message, "Ok", "success");
                            } else {
                                classUtilitites.switchReturns(data);
                            }
                        }
                    }


                },
                error: function (jqXHR, textStatus, errorThrown) {
                    // $('html').css('overflow', 'auto');
                    Loader.hide();

                    classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            });

            // result.dismiss can be "cancel", "overlay",
            // "close", and "timer"
        }
    });

}

function confirmFunctionTwoOptions() {

    var url_ajax_confirm = $(this).data("ajax_confirm");
    var url_ajax_deny = $(this).data("ajax_deny");
    var message = $(this).data("message");
    var title_msg = $(this).data("title");
    if ($(this).data("target_id") != undefined) var target_id = $(this).data("target_id");

    Swal.fire({
    title: title_msg,
    text: message,
    icon: "warning",
    showDenyButton: true,
    showCancelButton: true,
    confirmButtonText: confirm_msg_alert,
    denyButtonText: deny_msg_alert,
    cancelButtonText: cancel_msg_alert
    }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
            var urlAjax = url_ajax_confirm;
            Loader.show();
            // $('html').css('overflow', 'hidden');

            $.ajax({
                type: "POST",
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
                url: urlAjax,
                data: {},
                dataType: "json",
                success: function (data) {

                    if (data.error) {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        classUtilitites.showAlert(data.message, "Ok", "error");
                    } else {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        if (data.result.target != undefined) {
                            classUtilitites.switchReturns(data);
                        } else {
                            if (target_id != undefined) {
                                $('#' + target_id).remove();
                                classUtilitites.showAlert(data.message, "Ok", "success");
                            } else {
                                classUtilitites.switchReturns(data);
                            }
                        }
                    }


                },
                error: function (jqXHR, textStatus, errorThrown) {
                    // $('html').css('overflow', 'auto');
                    Loader.hide();

                    classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            });
        } else if (result.isDenied) {
            var urlAjax = url_ajax_deny;
            Loader.show();
            // $('html').css('overflow', 'hidden');

            $.ajax({
                type: "POST",
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
                url: urlAjax,
                data: {},
                dataType: "json",
                success: function (data) {

                    if (data.error) {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        classUtilitites.showAlert(data.message, "Ok", "error");
                    } else {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        if (data.result.target != undefined) {
                            classUtilitites.switchReturns(data);
                        } else {
                            if (target_id != undefined) {
                                $('#' + target_id).remove();
                                classUtilitites.showAlert(data.message, "Ok", "success");
                            } else {
                                classUtilitites.switchReturns(data);
                            }
                        }
                    }


                },
                error: function (jqXHR, textStatus, errorThrown) {
                    // $('html').css('overflow', 'auto');
                    Loader.hide();

                    classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            });
        }
    });

}

function confirmTextFunction() {

    var url_ajax = $(this).data("ajax");
    var message = $(this).data("message");
    var $inputVar = $(this).data("input");
    var placeholder = $(this).data("placeholder");

    if ($(this).data("target_id") != undefined) var target_id = $(this).data("target_id");

    var params = {
        title: title_msg_alert,
        text: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: confirm_msg_alert,
        cancelButtonText: cancel_msg_alert,
        reverseButtons: true
    };

    if ($inputVar != "") {
        Object.assign(params, { 'input': 'textarea' })
        Object.assign(params, {
            'inputAttributes': {
                'placeholder': placeholder,
                'required': 'required',
            }
        })
    }


    Swal.fire(params).then(function (result) {
        if (result.value) {
            Loader.show();
            // $('html').css('overflow', 'hidden');

            var key = $inputVar;
            var sendData = {};
            sendData[key] = result.value;

            $.ajax({
                type: "POST",
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
                url: url_ajax,
                data: sendData,
                dataType: "json",
                success: function (data) {

                    if (data.error) {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        classUtilitites.showAlert(data.message, "Ok", "error");
                    } else {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        if (target_id != undefined) {
                            $('#' + target_id).remove();
                            classUtilitites.showAlert(data.message, "Ok", "success");
                        } else {
                            classUtilitites.switchReturns(data);
                        }
                    }


                },
                error: function (jqXHR, textStatus, errorThrown) {
                    // $('html').css('overflow', 'auto');
                    Loader.hide();

                    classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            });

            // result.dismiss can be "cancel", "overlay",
            // "close", and "timer"
        }
    });

}

function confirmSelectFunction() {

    var url_ajax = $(this).data("ajax");
    var message = $(this).data("message");
    var $inputVar = $(this).data("input");
    var $options = $(this).data("input-options");
    var $placeholder = $(this).data("placeholder");

    if ($(this).data("target_id") != undefined) var target_id = $(this).data("target_id");

    var params = {
        title: title_msg_alert,
        text: message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: confirm_msg_alert,
        cancelButtonText: cancel_msg_alert,
        reverseButtons: true,

        input: 'select',
        inputOptions: $options,
        inputPlaceholder: $placeholder,
        showCancelButton: true,
        inputValidator: (value) => {
            return new Promise((resolve) => {
                if (value !== '') {
                    resolve()
                } else {
                    resolve('Você precisa selecionar um motivo')
                }
            })
        }
    };


    Swal.fire(params).then(function (result) {
        if (result.value) {
            Loader.show();
            // $('html').css('overflow', 'hidden');

            var key = $inputVar;
            var sendData = {};
            sendData[key] = result.value;

            $.ajax({
                type: "POST",
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
                url: url_ajax,
                data: sendData,
                dataType: "json",
                success: function (data) {

                    if (data.error) {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        classUtilitites.showAlert(data.message, "Ok", "error");
                    } else {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();
                        if (target_id != undefined) {
                            $('#' + target_id).remove();
                            classUtilitites.showAlert(data.message, "Ok", "success");
                        } else {
                            classUtilitites.switchReturns(data);
                        }
                    }


                },
                error: function (jqXHR, textStatus, errorThrown) {
                    // $('html').css('overflow', 'auto');
                    Loader.hide();

                    classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            });

            // result.dismiss can be "cancel", "overlay",
            // "close", and "timer"
        }
    });

}

function confirmMultiFieldFunction() {

    var url_ajax = $(this).data("ajax");
    var message = $(this).data("message");
    var $inputVar = $(this).data("input");
    var $options = $(this).data("input-options");
    var $placeholder = $(this).data("placeholder");
    var $html = $(this).data("html");
    var $html_form = $(this).data("html_form");

    if ($(this).data("target_id") != undefined) var target_id = $(this).data("target_id");

    var params = {
        title: title_msg_alert,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: confirm_msg_alert,
        cancelButtonText: cancel_msg_alert,
        reverseButtons: true,

        input: 'select',
        inputOptions: $options,
        inputPlaceholder: $placeholder,
        showCancelButton: true,
        inputValidator: (value) => {
            return new Promise((resolve) => {
                if (value !== '') {
                    var ok = true;

                    $($html_form).find('input, select, textarea').each(function () {
                        if(($(this).attr('required') !== 'undefined') && $(this).val() == ''){
                            ok = false;
                        }
                    });

                    if (ok) {
                        resolve()
                    }else{
                        resolve('Você precisa preencher os campos obrigatórios')
                    }

                } else {
                    resolve('Você precisa selecionar um motivo')
                }
            })
        },



        html: message + '<br><br>' + JSON.parse($html),
        focusConfirm: false,
        preConfirm: (result) => {

            var key = $inputVar;
            var sendData = [{
                'name': key,
                'value': $(document).find('.swal2-select').find(":selected").val()
            }];

            var arr = $($html_form).serializeArray();
            // sendData[key] = result.value;
            // console.log(arr);

            return sendData.concat(arr);

        }
    };

    Swal.fire(params).then(function (result) {

        if (result.isConfirmed) {


            var sendData = {};
            result.value.forEach(function (value, index) {
                sendData[value.name] = value.value;
            });


            if (result) {
                Loader.show();
                // $('html').css('overflow', 'hidden');


                $.ajax({
                    type: "POST",
                    headers: {
                        'X-CSRF-TOKEN': CSRF_TOKEN
                    },
                    url: url_ajax,
                    data: sendData,
                    dataType: "json",
                    success: function (data) {

                        if (data.error) {
                            // $('html').css('overflow', 'auto');
                            Loader.hide();
                            classUtilitites.showAlert(data.message, "Ok", "error");
                        } else {
                            // $('html').css('overflow', 'auto');
                            Loader.hide();
                            if (target_id != undefined) {
                                $('#' + target_id).remove();
                                classUtilitites.showAlert(data.message, "Ok", "success");
                            } else {
                                classUtilitites.switchReturns(data);
                            }
                        }


                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        // $('html').css('overflow', 'auto');
                        Loader.hide();

                        classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                        if (APP_DEBUG != "ON") {
                            setTimeout(function () {
                                location.reload();
                            }, 1000);
                        }
                    }
                });

                // result.dismiss can be "cancel", "overlay",
                // "close", and "timer"
            }
        }
    });


}

function getAditionalOrders() {
    var element = $(this);

    $('#id_orders').html('');

    if ($('#id_order_packing').val() != "") {

        Loader.show();
        // $('html').css('overflow', 'hidden');


        $.ajax({
            type: "GET",
            headers: {
                'X-CSRF-TOKEN': CSRF_TOKEN
            },
            url: HOST_URL + "/packing/listOrders/",
            data: {
                'id_order_packing': $('#id_order_packing').val()
            },
            dataType: "json",
            success: function (data) {
                // $('html').css('overflow', 'auto');
                Loader.hide();

                if (data.error) {
                    classUtilitites.showAlert(data.message, "Ok", "error");
                } else {

                    $('#id_orders').html(data.result.html);

                }

            },
            error: function (jqXHR, textStatus, errorThrown) {
                // $('html').css('overflow', 'auto');
                Loader.hide();
                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        });
    }
}

function checkCategorySub() {
    var element = $(this);

    if ($(this).val() != "" && element.data('checksub') != undefined && element.data('checksub') != "") {

        if ($('.' + element.data('id')).length > 0) {
            $('.' + element.data('id')).remove();
        }

        Loader.show();
        // $('html').css('overflow', 'hidden');

        $.ajax({
            type: "GET",
            headers: {
                'X-CSRF-TOKEN': CSRF_TOKEN
            },
            url: element.data('checksub'),
            data: {
                'id': element.val(),
                'id_father': element.data('id'),
                'old': element.attr('data-old')
            },
            dataType: "json",
            success: function (data) {

                // $('html').css('overflow', 'auto');
                Loader.hide();

                element.attr('data-old', element.val());

                if (!data.error) {
                    $("." + element.data('after')).after(data.result.html);
                    classUtilitites.formSelects();
                }

            },
            error: function (jqXHR, textStatus, errorThrown) {
                // $('html').css('overflow', 'auto');
                Loader.hide();

                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        });
    }
}

function selectAction() {
    var element = $(this);

    var elementData = $(this).data();
    if(elementData.select2 !== undefined) delete elementData.select2;

    // console.log(elementData)

    Loader.show();
    // $('html').css('overflow', 'hidden');

    if(elementData.field !== undefined){
        elementData[elementData.field] = element.val();
    }

    var sendData = {
        'value': element.val(),
        'data': elementData
    }



    $.ajax({
        type: "POST",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: element.data('urlajax'),
        data: sendData,
        dataType: "json",
        success: function (data) {

            // $('html').css('overflow', 'auto');
            Loader.hide();

            if (!data.error) {
                classUtilitites.switchReturns(data, element);
            }

        },
        error: function (jqXHR, textStatus, errorThrown) {
            // $('html').css('overflow', 'auto');
            Loader.hide();

            classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });
}

function changeSubmit() {
    var element = $(this);

    // console.log('aqui',element);

    $(element.data('target')).submit();
}

function btCopy() {
    var element = $(this);

    var content = element.attr('data-content');

    $(document).find(element.attr('data-target')).val(content);

    $('#myModal' + COUNT_MODAL).modal("hide");

    if($(document).find(element.attr('data-target')).val() != ''){
        if($(document).find('#whatsapi-send-button').length > 0){
            $('#whatsapi-send-button').removeAttr('disabled');
            $("#whatsapi-send-button").show();
            $("#recordButton").hide();
        }

    }
}

function selectCopy() {
    var element = $(this);

    var content = element.find(":selected").attr('data-content');

    $(document).find(element.attr('data-target')).val(content);
}

 window.showModal = function(e, modal = "", callback = "") {

    var id_modal = createModal();

    // check modal has attribute for size
    let classSizeModal = '';
    const attr = $(this).attr('data-modal_size');
    if($(this).attr('data-callback') != undefined){
        callback = $(this).attr('data-callback');
    }
    if (typeof attr !== 'undefined' && attr !== false) {
        classSizeModal = attr;
    }

    $('#' + id_modal).find('.modal-content').addClass(classSizeModal +' d-flex align-items-center justify-content-center').html('<div class="spinner spinner-primary spinner-lg mx-auto d-block vertical-center"></div>');
    if (callback != "") {
        $('#' + id_modal).attr('data-callback', callback);
    }
    if (modal == "") {
        var load = $(this).data("modal");
    } else {
        var load = modal;
    }

    // product-combo-multi >>> INICIO do trecho com prova mecanica (nao mova os marcadores)
    // O orderFieldsWrap decide esconder a .row por MEDIDA de layout (row.clientHeight == 0).
    // No Bootstrap 4.5.2 o display:block do modal so chega DEPOIS da transicao do backdrop
    // (.fade{transition:opacity .15s}), entao chamar o agrupador dentro do callback do .load()
    // e corrida: com GET rapido TODA .row mede 0 e os blocos somem, em silencio.
    // Aqui ele so roda quando o modal JA esta pintado (shown.bs.modal) E o HTML JA chegou
    // (callback do .load) - em qualquer ordem de chegada, e uma vez so.
    var wrapModalShown  = false;
    var wrapModalLoaded = false;
    var wrapModalDone   = false;
    var orderModalFields = function () {
        if (wrapModalShown === false || wrapModalLoaded === false || wrapModalDone === true) {
            return;
        }
        wrapModalDone = true;
        var modalRoot = document.getElementById(id_modal);
        // o id #form-auto-reorder tambem existe na aba ATRAS do modal: procurar a partir da raiz
        if (modalRoot && modalRoot.querySelector('#form-auto-reorder')) {
            classUtilitites.orderFieldsWrap(modalRoot);
        }
    };
    $('#' + id_modal).one('shown.bs.modal', function () {
        wrapModalShown = true;
        orderModalFields();
    });

    $('#' + id_modal).modal('show');
    $('#' + id_modal).find('.modal-content').load(load, function () {
        masksInputs();
        classUtilitites.formSelects();
        formValidade();
        // classUtilitites.sortable();

        if($(e.target).hasClass('modal-gallery')){
            classUtilitites.loadGallery();
        }
        if ($('.cardAutoLoad').length > 0) {
            cardAutoLoad();
        }

        wrapModalLoaded = true;
        orderModalFields();
    });
    // product-combo-multi <<< FIM do trecho com prova mecanica

    // se modal for 'large', remove padding right
    if($('#' + id_modal).find('.modal-content').hasClass('modal-large')){
        $('#' + id_modal).css({'paddingRight' : 0});
    }

    // se modal tiver scroll na div, remove scroll geral dele
    if( $('#' + id_modal).find('.modal-content').hasClass('modal-noscroll') ){
        $('#' + id_modal).addClass('noscroll');
        $('body').addClass('noscroll');
    }

    // escurece o bg do modal se o novo tiver classe para isso
    if($('#' + id_modal).find('.modal-content').hasClass('bg-backdrop-dark')){
        $('.modal-backdrop').addClass('bg-backdrop-dark');
    }

    $(document).on('hidden.bs.modal', '#' + id_modal, afterCloseModal);
}

function showIframe(e, modal = "", callback = "") {
    var id_modal = createModal();

    $('#' + id_modal).find('.modal-content').html('<div class="spinner spinner-primary spinner-lg mr-15 vertical-center"></div>');
    if (callback != "") {
        $('#' + id_modal).attr('data-callback', callback);
    }

    var url = $(this).data("iframe");

    $('#' + id_modal).modal('show');
    $('#' + id_modal).find('.modal-content').html('<iframe src="' + url + '" class="w-100 h-100" frameborder="0"></iframe>');

    $(document).on('hidden.bs.modal', '#' + id_modal, afterCloseModal);
}

function afterCloseModal() {

    if ($('#myModal' + COUNT_MODAL).attr('data-callback') != undefined) {
        var element = $('#myModal' + COUNT_MODAL);
        var url_ajax = element.attr('data-callback');

        Loader.show();
        $('body').removeClass('noscroll');
        // $('html').css('overflow', 'hidden');

        setTimeout(function () {
            $.ajax({
                type: "POST",
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
                url: url_ajax,
                data: $(this).data(),
                dataType: "json",
                success: function (data) {

                    // $('html').css('overflow', 'auto');
                    Loader.hide();

                    classUtilitites.switchReturns(data, element);

                },
                error: function (jqXHR, textStatus, errorThrown) {
                    // $('html').css('overflow', 'auto');
                    Loader.hide();

                    classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
                    if (APP_DEBUG != "ON") {
                        setTimeout(function () {
                            location.reload();
                        }, 1000);
                    }
                }
            });
        }, 0);

    }

    $('#myModal' + COUNT_MODAL).remove();
    if ($('.modal').length == 1) {
        if (!$('.modal').is(":visible")) {
            $('.modal').remove();
        }
    }
}

function createModal() {
    COUNT_MODAL = COUNT_MODAL + 1;

    var id_modal = 'myModal' + COUNT_MODAL;

    $('body').append('<div id="' + id_modal + '" class="modal fade" data-backdrop="static"  role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true"><div class="modal-dialog modal-lg  modal-content" data-backdrop="static" aria-labelledby="staticBackdrop" role="document"></div></div>');

    return id_modal;
}

function searchZipcode() {
    var input = $(this);
    var CEP = $(this).val();
    if (CEP.length == 9) {
        $.ajax({
            url: "https://viacep.com.br/ws/" + CEP.replace('-', '') + '/json/',
            type: 'get',
            dataType: 'jsonp',
            success: function (data) {
                var form = input.closest('form');

                var ibge = data.ibge;
                var cod_city = ibge.slice(2);
                var cod_state = ibge.slice(0, 2);

                var city = data.localidade;
                var district = data.bairro;
                var address = data.logradouro;
                var state = data.uf;

                city = city.normalize('NFC');
                district = district.normalize('NFC');
                address = address.normalize('NFC');

                if(form.find('input[name="address"]').length !=0 ){
                    form.find('input[name="address"]').val(address);
                    form.find('input[name="district"]').val(district);
                    form.find('input[name="city"]').val(city);
                    form.find('input[name="cod_city"]').val(cod_city);
                    form.find('input[name="cod_state"]').val(cod_state);
                    form.find('select[name="state"]').val(state);
                    form.find('select[name="number"]').focus();
                }else{
                    form.find('#address').val(address);
                    form.find('#district').val(district);
                    form.find('#city').val(city);
                    form.find('#cod_city').val(cod_city);
                    form.find('#cod_state').val(cod_state);
                    form.find('#state').val(state);
                    form.find('#number').focus();
                }
            },
            error: function (result) {
                // $('#shipping_obsevations').value('Endereço não encontrado, valor padrão adotado');
            }
        });
    }
}

function elementChangeHideShow() {
    var element = $(this);
    var changed = element.val();

    $('.elements-pull').addClass('hide');
    $('.' + changed).removeClass('hide').addClass('show');

}

function checkChange() {
    var element = $(this);
    var changed = element.val();

    if (element.is(':checked')) {
        $('.' + element.data('target')).addClass('show').removeClass('hide');
    } else {
        $('.' + element.data('target')).addClass('hide').removeClass('show');
    }

}

function elementChange() {
    var element = $(this);
    var dataValues = $(this).data();
    var newValue = $(this).val();
    var url_ajax = $(this).attr('data-ajax');

    dataValues.newValue = newValue;

    $.ajax({
        type: "POST",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: url_ajax,
        data: dataValues,
        dataType: "json",
        success: function (data) {
            // $('html').css('overflow', 'auto');

            if (data.error && element.is('select') && (element.data('element') || '').toString().indexOf('stage_') === 0) {
                element.val('0');
            }

            classUtilitites.switchReturns(data, element);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // $('html').css('overflow', 'auto');

            classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });

}

function cardAutoLoad() {
    $('.cardAutoLoad').each(function () {
        let el = $(this);
        let url = el.data('url');

        axios.get(url)
            .then(function (response) {
                let data = response.data;

                if (data.error === false) {
                    let result = data.result;
                    el.html(result.html);
                }

            })
            .catch(function (error) {
                el.find('.card-body').html('<div class="text-muted text-center p-20" title="'+error+'"><i class="fas fa-exclamation-circle"></i>Falha ao carregar</div>');
            });
    });
}

// Ao marcar o checkbox, limpa o campo indicado em data-clear-target (nome do campo)
function clearTargetOnCheck() {
    if (this.checked) {
        $('[name="' + $(this).data('clear-target') + '"]').val('');
    }
}

function inputChange() {
    let element = $(this);

    let name = $(this).attr('name');
    let value = $(this).val();

    let url_ajax = $(this).attr('data-ajax');

    let data = {
        [name]: value
    }

    Loader.show();

    $.ajax({
        type: "POST",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: url_ajax,
        data: data,
        dataType: "json",
        success: function (data) {
            // $('html').css('overflow', 'auto');
            Loader.hide();

            classUtilitites.switchReturns(data, element);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // $('html').css('overflow', 'auto');
            Loader.hide();

            classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });

}

function beforeCheck() {
    var element = $(this);
    var modal = element.data('modal_open');
    var ajax = element.data('ajax');

    // element.on('change', );
    // element.change(function () {
    element.prop("checked", false);
    showModal(Event, modal, ajax);

    // if (this.checked) {

    // } else {
    //     ajaxFunction(Event, element);
    // }
    // });
}

function formValidade() {

    jQuery.validator.addMethod('cpf', function (value, element) {

        value = jQuery.trim(value);
        value = value.replace('.', '');
        value = value.replace('.', '');
        cpf = value.replace('-', '');
        while (cpf.length < 11) cpf = "0" + cpf;
        var expReg = /^0+$|^1+$|^2+$|^3+$|^4+$|^5+$|^6+$|^7+$|^8+$|^9+$/;
        var a = [];
        var b = new Number;
        var c = 11;
        for (i = 0; i < 11; i++) {
            a[i] = cpf.charAt(i);
            if (i < 9) b += (a[i] * --c);
        }
        if ((x = b % 11) < 2) { a[9] = 0 } else { a[9] = 11 - x }
        b = 0;
        c = 11;
        for (y = 0; y < 10; y++) b += (a[y] * c--);
        if ((x = b % 11) < 2) { a[10] = 0; } else { a[10] = 11 - x; }

        var retorno = true;
        if ((cpf.charAt(9) != a[9]) || (cpf.charAt(10) != a[10]) || cpf.match(expReg)) retorno = false;

        return this.optional(element) || retorno;

    }, 'Informe um CPF válido');

    $('form:not(.no-validate)').each(function (element) {
        if ($(this).hasClass('no-validate') === false) {
            _formValidade($(this));
        }
    });
}

window._formValidade = function(form) {
    form.validate({
        // ignore: [], // importante para validar select2
        focusInvalid: false, // evita o warning

        errorClass: 'error',//"is-invalid",
        validClass: "is-valid",

        // Callback disparado quando a validação falha
        invalidHandler: function(event, validator) {
            // validator.errorList contém todos os erros encontrados no formulário
            if (validator.errorList.length) {
                var $primeiroInvalido = $(validator.errorList[0].element);

                // Rola a página suavemente até o primeiro campo inválido
                $('html, body').animate({
                    scrollTop: $primeiroInvalido.offset().top - 100 // 100px de offset para topo/header fixo
                }, 500);

                // Opcional: foca o campo automaticamente
                $primeiroInvalido.focus();
            }
        },

        errorPlacement: function (error, element) {
            if (element.hasClass("select2-hidden-accessible")) {
                error.insertAfter(element.next(".select2"));
            } else {
                // descarta só labels de erro idênticos já existentes no campo (nos grupos
                // repetíveis a mesma mensagem se acumulava por linha); mensagens diferentes ficam
                element.siblings('label.error').filter(function () {
                    return $(this).text() === error.text();
                }).remove();
                error.insertAfter(element);
            }
        },

        highlight: function (element) {
            if ($(element).hasClass("select2-hidden-accessible")) {
                $(element).next(".select2")
                    .find(".select2-selection")
                    .addClass("is-invalid");
            } else {
                $(element).addClass("is-invalid");
            }
        },

        unhighlight: function (element) {
            if ($(element).hasClass("select2-hidden-accessible")) {
                $(element).next(".select2")
                    .find(".select2-selection")
                    .removeClass("is-invalid");
            } else {
                $(element).removeClass("is-invalid");
            }
        }
    });

    form.find('input, select, textarea').each(function () {
        var element = $(this);
        var name = element.attr('name');

        if (typeof element.data('validate') != 'undefined') {
            if (element.data('validate')) {
                var validate = element.data('validate');


                if (validate.length > 0) {
                    each(validate, function (response) {
                        // console.log(response.validate);

                        switch (response.validate) {
                            case "required":

                                if ($(element).is("select")) {

                                    $.validator.addMethod("valueNotEquals", function(value, element, arg) {
                                        return arg !== value;
                                    }, response.message);

                                    element.rules('add', {
                                        valueNotEquals: 'Selecione...'
                                    });

                                    if (document.activeElement) {
                                        document.activeElement.blur();
                                    }

                                } else {
                                    element.rules('add', {
                                        required: response.value,
                                        messages: {
                                            required: response.message,
                                        }
                                    });
                                }
                                break;
                            case "email":
                                element.rules('add', {
                                    email: response.value,
                                    messages: {
                                        email: response.message,
                                    }
                                });
                                break;
                            case "cpf":
                                // element.rules('add', {
                                //     cpf: response.value,
                                //     messages: {
                                //         cpf: response.message,
                                //     }
                                // });
                                break;
                            case "userfile":
                                element.rules('add', {
                                    accept: response.value,
                                    messages: {
                                        accept: response.message,
                                    }
                                });
                                break;
                            case "remote":
                                element.rules('add', {
                                    remote: {
                                        url: response.value,
                                        type: 'POST',
                                        dataType: 'json',
                                        dataFilter: function (data) {
                                            let response = JSON.parse(data);

                                            element.closest('div').find('span.error').remove();
                                            if (response.result.link !== undefined) {
                                                element.after(response.result.link);
                                            } else {
                                                if (response.error) {
                                                    classUtilitites.showAlert(response.message, '', 'error');
                                                }
                                            }

                                            return !response.error;
                                        },
                                    },
                                    messages: {
                                        remote: response.message,
                                    }
                                });
                                break;
                            case "equalTo":
                                element.rules('add', {
                                    equalTo: "#" + response.value,
                                    messages: {
                                        equalTo: response.message,
                                    }
                                });
                                break;
                            case "min":
                                // product-combo-multi: sem este case a regra 'min' cai na mensagem
                                // padrao do plugin ("...maior ou igual a 0.001"), que nao e o texto
                                // do desenho. A mensagem vem do PHP (array 'validate').
                                var minRules = {
                                    min: parseFloat(response.value),
                                };
                                if (response.message) {
                                    minRules.messages = {
                                        min: response.message,
                                    };
                                }
                                element.rules('add', minRules);
                                break;
                        }
                    });
                }
            }
        }
    }).change(function () {
        let element = $(this);
        if (element.val() == '') {
            element.closest('div').find('label.error, span.error').remove();
        }
    });
}

function btNotifications() {

    var element = $(this);
    var url_ajax = $(this).data("ajax");
    var divTarget = $(this).data("target");
    var divTargetAfter = $(this).data("target-after");

    $('.' + divTarget).html('<div class="spinner spinner-primary spinner-lg mr-15 vertical-center force-center"></div>');

    $.ajax({
        type: "GET",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: url_ajax,
        data: {},
        dataType: "json",
        success: function (data) {

            if (data.error) {
                classUtilitites.showAlert(data.message, "Ok", "error");
            } else {

                $('.' + divTarget).html(data.result.html);


                $.ajax({
                    type: "GET",
                    headers: {
                        'X-CSRF-TOKEN': CSRF_TOKEN
                    },
                    url: divTargetAfter,
                    data: {},
                    dataType: "json",
                    success: function (data) {
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                    }
                });

            }

        },
        error: function (jqXHR, textStatus, errorThrown) {
            classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });
}

function btCheckNotifications() {

    var element = $(this);
    var url_ajax = $(this).data("ajax");
    var divTarget = $(this).data("target");
    var divTargetAfter = $(this).data("target-after");

    $('.' + divTarget).html('<div class="spinner spinner-primary spinner-lg mr-15 vertical-center force-center"></div>');

    $.ajax({
        type: "GET",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: url_ajax,
        data: {},
        dataType: "json",
        success: function (data) {

            if (data.error) {
                classUtilitites.showAlert(data.message, "Ok", "error");
            } else {

                $('.' + divTarget).html(data.result.html);


                $.ajax({
                    type: "GET",
                    headers: {
                        'X-CSRF-TOKEN': CSRF_TOKEN
                    },
                    url: divTargetAfter,
                    data: {},
                    dataType: "json",
                    success: function (data) {
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                    }
                });

            }

        },
        error: function (jqXHR, textStatus, errorThrown) {
            classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });
}

function checkNotifications() {


    $.ajax({
        type: "GET",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: HOST_URL + '/checkNewNotifications',
        data: {},
        dataType: "json",
        success: function (data) {
            if (data.result) {

                $('.btn-notif').addClass('pulse');

            }
        },
        error: function (jqXHR, textStatus, errorThrown) {
            // console.log(HOST_URL + '/checkNewNotifications', jqXHR, textStatus, errorThrown);
        }
    });


}

function clearPulseNotifications() {
    $('.btn-notif').removeClass('pulse');
}

function reportExport() {

    let card = $('.card.card-custom.card-export');
    let element = $(this);
    let url = element.data('export');
    let data = $('.reportFields').serializeArray()

    card.prepend('<div class="spinner-alert alert alert-success">Carregando...</div>');

    Loader.wrap(Axios.post(url, { reportFields: data }))
        .then(function (response) {

            let data = response.data;

            let html = '<div class="alert ' + (data.error ? 'alert-danger' : 'alert-success') + '" role="alert" style="display:none;">';
            html += data.message;
            html += '</div>';

            card.find('.spinner-alert').slideUp('slow', function () {
                $(this).remove();

                setTimeout(() => {
                    $('.card.card-custom.card-export').prepend(html);


                    card.find('.alert').slideDown('slow', function () {
                        setTimeout(() => {
                            $('.alert').slideUp('slow', function () {
                                $(this).remove();
                            });
                        }, 2500);
                    });
                }, 100);

            });
        })
        .catch(function (error) {
            card.find('.spinner-alert').remove();
            classUtilitites.showCommunicationError(error);
        });
}

function countdown(remaining) {
    let time = $('#countdownReload').attr('data-time');
    time = parseInt(time);

    var interval = setInterval(function () {
        time--

        $('#countdownReload').attr('data-time', time).html(time);
        if (time <= 0) {
            clearInterval(interval);
            window.location.reload();
        }
    }, 1000);
}

function copyText() {
    var input = $($(this).data('input'));

    input.select();
    document.execCommand("copy");
}

function changePage() {

    var element = $(this);
    var url_ajax = $(this).data("ajax");
    var divTarget = $(this).data("target");

    $('.' + divTarget).html('<div class="spinner spinner-primary spinner-lg mr-15 vertical-center force-center"></div>');

    $.ajax({
        type: "GET",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: url_ajax,
        data: {},
        dataType: "json",
        success: function (data) {

            if (data.error) {
                showAlert(data.message, "Ok", "error");
            } else {

                $('.' + divTarget).html(data.result.html);
                classUtilitites.formSelects();
                classUtilitites.createOldForm();

            }

        },
        error: function (jqXHR, textStatus, errorThrown) {
            showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });
}

function autocompleteField() {

    var element = $(this);
    var fields = $(this).data('fields');

    element.autocomplete({
        source: function (request, response) {
            $.ajax({
                url: element.data('ajax'),
                dataType: "jsonp",
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                },
                data: {
                    term: request.term
                },
                success: function (data) {
                    response(data);
                }
            });
        },
        minLength: 2,
        select: function (event, ui) {
            if (fields != "") {
                var explode = fields.split(",");

                explode.forEach(function (value, index) {
                    var name_field = value;

                    if (ui.item[name_field] != undefined) $('input[name="' + value + '"]').val(ui.item[name_field]);
                });

            }
        }
    });
}

function formSelectInfo() {
    let element = $(this);
    let name = element.attr('name')
    let value = element.val();

    $('.element-result[name="' + name + '"]').val(value);
}

function masksInputs() {
    classUtilitites.masksInputs();
    if ($('.change-mask').length > 0) {
        $(document).on('change', '.change-mask', function() {
            $('input#document').removeClass('mask-cnpj');
            $('input#document').removeClass('mask-cnpj-15');
            $('input#document').removeClass('mask-cpf');

            let elCurrent = $('.change-mask:checked').val();
            if (elCurrent == 1) {
                $('input#document').addClass('mask-cpf');
            }else{
                $('input#document').addClass('mask-cnpj');
                // $('input#document').addClass('mask-cnpj-15');
            }

            classUtilitites.masksInputs();
        });
    }
}

function startClassSVG() {

    var $icon = $(this);
    if ($icon.hasClass('svg-inline')) return true;

    var bg = $icon.css('background-image').replace('url(', '').replace(')', '').replace(/\"/g, '');

    if (bg && bg != 'none') $.get(bg, function (resp) {
        $icon.html($(resp).find('svg')).addClass('svg-inline').trigger('svg-ready');
    });

}

function sendNotification() {
    Push.create('Hello World!')
}

function changeVisibility() {
    var target = $(this).data('target');

    if ($(target).hasClass('hide')) {
        $(target).removeClass('hide');
        $(target).addClass('show');
    } else {
        $(target).removeClass('show');
        $(target).addClass('hide');
    }
}

function btHideElement() {
    var target = $(this).data('target');

    $(target).removeClass('show');
    $(target).addClass('hide');
}

function changeVisibilityAjax() {
    var target = $(this).data('target');
    var url_ajax = $(this).data("ajax");

    if ($(target).hasClass('hide')) {
        $(target).removeClass('hide');
        $(target).addClass('show');

        $(target).html('<div class="d-flex justify-content-center h-100"><div class="spinner"></div></div>');

        var url_ajax = $(this).data("ajax");

        $.ajax({
            type: "POST",
            headers: {
                'X-CSRF-TOKEN': CSRF_TOKEN
            },
            url: url_ajax,
            data: $(this).data(),
            dataType: "json",
            success: function (data) {
                if (data.error) {
                    showAlert(data.message, "Ok", "error");
                } else {
                    $(target).html(data.result.html);
                }
            },
            error: function (jqXHR, textStatus, errorThrown) {
                // $('html').css('overflow', 'auto');

                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        });

    } else {
        $(target).removeClass('show');
        $(target).addClass('hide');

        $(target).html('<div class="d-flex justify-content-center h-100"><div class="spinner"></div></div>');
    }
}

function copyClipboard() {

    var copyText = document.getElementById("valueClipboard");

    copyText.select();
    copyText.setSelectionRange(0, 99999); // For mobile devices

    navigator.clipboard.writeText(copyText.value);

}

function copyClipboardHidden() {
    /* Get the text field */
    var copyTextInput = $(this).attr('data-targetID');

    /* Prevent iOS keyboard from opening */
    $(copyTextInput).readOnly = true;

    /* Change the input's type to text so its text becomes selectable */
    $(copyTextInput).attr('type', 'text');

    /* Select the text field */
    // $(copyTextInput).select();
    // $(copyTextInput).setSelectionRange(0, 99999); /* For mobile devices */

    /* Copy the text inside the text field */
    navigator.clipboard.writeText($(copyTextInput).val());

    /* Change the input's type back to hidden */
    $(copyTextInput).attr('type', 'hidden');

    $(this).removeClass('btn-light');
    $(this).addClass('btn-light-success pulse pulse-success');
    $(this).append('<span class="pulse-ring"></span>');

    setTimeout(() => {
        $(this).removeClass('btn-light-success');
        $(this).removeClass('pulse');
        $(this).removeClass('pulse-success');
        $(this).addClass('btn-light');
        $(this).find('.pulse-ring').remove();
    }, 1500);

    if($(this).attr('data-original-title') != undefined){
        var message = $(this).attr('data-original-title');
        $(this).attr('data-original-title', 'Copiado');
        setTimeout(() => {
            $(this).attr('data-original-title', message);
        }, 1000);
    }
}

function searchCategory(){
    let el = $(this);

    let parent = el.parent().parent();
    let input = parent.find('.search-category');
    let url = input.data('url');
    let parent_id = input.data('parent_id');

    $('.table-custom-' + parent_id + ' .table-list-item').hide()

    Loader.wrap(axios.post(url, {'search': input.val() }))
        .then(function(response){
            let data = response.data;

            if (data.error == false) {
                let result = data.result;

                if (result.length == 0) {
                    $('.table-custom-' + parent_id + ' .table-list-item').show();
                } else {
                    result.forEach(function (value) {
                        $('#category_item-' + value).show();
                    });
                }
            }
        })
        .catch((error) => classUtilitites.showCommunicationError(error));
}

function attachCategoryProduct()
{
    let element = $(this);

    let product_id = element.val();
    let category_id = element.data('category_id');
    let parent_id = element.data('parent_id');
    let url = element.data('url');

    let data = {
        'product_id': product_id,
        'category_id': category_id,
        'parent_id': parent_id
    };

    $('.parent-attach').addClass('d-none');

    axios.post(url, data)
        .then(function(response){
            let data = response.data;

            $('.parent-attach').removeClass('d-none');
        });
}

function saveCatalog()
{
    let element = $(this);

    let url = $('.save-catalog').data('url');
    let nm_catalog = $('.nm_catalog').val();
    let catalog_id = $('#catalog_id').val();
    let id_user = $('.id_user').val();
    let cover = $('input[name="cover"]:checked').val();
    let all = $('input[name="all"]:checked').val();
    let cover_product = $('input[name="cover_product"]:checked').val();
    let description = $('input[name="description"]:checked').val();
    let outline = $('input[name="outline"]:checked').val();
    let finishes = $('input[name="finishes"]:checked').val();
    let layout = $('input[name="layout"]:checked').val();

    let product_ids = [];
    if ($('input[name="product[]"]').length > 0) {
        $('input[name="product[]"]').each(function(index){
            product_ids[index] = $(this).val();
        });
    }

    let data = {
        catalog_id: catalog_id,
        nm_catalog: nm_catalog,
        id_user: id_user,
        cover: cover,
        all: all,
        cover_product: cover_product,
        description: description,
        outline: outline,
        finishes: finishes,
        layout: layout,
        product_ids: product_ids,
    }

    Loader.wrap(axios.post(url, data))
        .then(function(response){
            let data = response.data;

            if (data.error == false) {
                let result = data.result
                $('#catalog_id').val(result.id);
                classUtilitites.showAlert(data.message, "Ok", 'success');
            }else{
                classUtilitites.showAlert(data.message, "Ok");
            }
        })
        .catch((error) => classUtilitites.showCommunicationError(error));
}

function executeAjaxOnLoad(index, element) {
    $.ajax({
        type: "POST",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: $(element).data('ajax'),
        data: $(element).data(),
        dataType: "json",
        success: function (data) {
            classUtilitites.switchReturns(data, element);
        },
        error: function (jqXHR, textStatus, errorThrown) {
            classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");
            if (APP_DEBUG != "ON") {
                setTimeout(function () {
                    location.reload();
                }, 1000);
            }
        }
    });
}

function contactField(){
    if ($('input[name="contact_field"]').length == 0) {
        return false;
    }

    let element = $('input[name="contact_field"]:checked');
    let value = element.val();

    if (value == 1) {
        $('input[name="contact_email"]').closest('div').show();
        $('input[name="email"]').closest('div').hide();
    }else{
        $('input[name="contact_email"]').closest('div').hide();
        $('input[name="email"]').closest('div').show();
    }
}

function autoReload(){
    let autoReload = $('.auto-reload');
    let counter = autoReload.find('.counter').text();



    let autoReloadFunc = setInterval(() => {
        counter--;
        autoReload.find('.counter').text(counter);

        const _progressReload = document.getElementById('progress-reload');
        if(_progressReload) {
            let reloadPorcent = parseInt(((counter/45) * 100));
            // console.log(`porcentagem = ${reloadPorcent}%`);
            _progressReload.style.width=`${reloadPorcent}%`;
            _progressReload.setAttribute('aria-valuenow',reloadPorcent);
        }

        if (counter <= 0) {

            let formSerialize = $('.form-ajax-dashboard').serialize();
            let url = window.location.origin + window.location.pathname +'?'+ formSerialize;

            window.location = url;
            clearInterval(autoReloadFunc);
        }
    }, 1000);
}

function formatPlaintextSelectValue(value) {

    if (typeof value !== 'string' || value.indexOf('<option') === -1) {
        return value;
    }

    let labels = $('<div>').html(value).find('option[selected]').map(function () {
        return $(this).text().trim();
    }).get();

    return labels.join(', ');
}

function selectCallbackField(event, extra){

    // trigger sintético (ex.: reload de aba/página) — não é uma mudança real do
    // usuário no campo; a chamada ajax roda normalmente (outros campos do result
    // ainda precisam ser sincronizados), mas as duas funções abaixo não devem rodar
    let isSynthetic = extra != undefined && extra.synthetic;

    let value = $(this).val();
    let callbackField = $(this).attr('data-callback-field');
    let isEmpty = Array.isArray(value) ? value.length === 0 : (!value || !value.trim());

    if (isEmpty) {
        let parsedCallbackField = JSON.parse(callbackField);

        if (parsedCallbackField.fields) {
            Object.entries(parsedCallbackField.fields).forEach(([field, marker]) => {
                if (marker === 'option-selected' || marker === 'options-disabled') {
                    return;
                }

                let element = document.getElementById(field);

                if (!element) {
                    return;
                }

                if (element.tagName == 'INPUT' || element.tagName == 'SELECT') {
                    element.value = '';
                }

                if (element.tagName == 'P' || element.tagName == 'DIV') {
                    element.textContent = '';
                }
            });
        }

        return;
    }

    callbackField       = JSON.parse(callbackField);
    const linksObj      = Object.keys(callbackField.fields || {});
    const htmlOverlayLoading   = '<div class="htmlOverlayLoading"><div class="spinner spinner-primary spinner-sm"></div></div>';

    if (callbackField.field_readonly) {
        Object.entries(callbackField.field_readonly).forEach(([field, triggerValues]) => {
            let isReadonly = triggerValues.includes(String(value));
            $("[name='" + field + "']").prop('readonly', isReadonly).toggleClass('form-control-readonly-active', isReadonly);
        });
    }

    if(!isSynthetic){

        // constroi loader para cada campo que será atualizado, exceto o próprio select que disparou o evento
        linksObj.forEach((field) => {
            // console.log(field);
            if (field === 'option-selected') {
                return;
            }
            $("[name='" + field + "']").parent().append(htmlOverlayLoading);
            $("[name='" + field + "']").parent().find('.htmlOverlayLoading').addClass('active').show(400);
        });
    }

    let postData = { value: value };

    if (callbackField.fields) {
        postData.field_return = callbackField.fields;
    }

    if (callbackField.field_option_selected) {
        let fieldOptionSelected = {};

        Object.entries(callbackField.field_option_selected).forEach(([key, fieldConfig]) => {
            let filterName = fieldConfig.filter;
            let element    = $("input[name='" + filterName + "'], select[name='" + filterName + "'], textarea[name='" + filterName + "']");

            fieldOptionSelected[key] = {
                'filter': element.length ? element.val() : filterName,
                'options': fieldConfig.options
            };
        });

        postData.field_option_selected = fieldOptionSelected;
    }

    if (callbackField.fields_merge) {
        let mergedValues = {};

        Object.entries(callbackField.fields_merge).forEach(([mergeName, items]) => {
            let overrideField   = (callbackField.fields_merge_override || {})[mergeName];
            let overrideElement = overrideField ? $("input[name='" + overrideField + "'], select[name='" + overrideField + "']") : $();
            let isOverridden    = overrideElement.length > 0 && (overrideElement.is(':checkbox') ? overrideElement.is(':checked') : overrideElement.val() == 1);

            if (isOverridden) {
                mergedValues[mergeName] = [];
                return;
            }

            let subMerged = [];

            items.forEach((item) => {
                let action = $("input[name='" + item.target_action + "']");

                if (action.length === 0 || !action.is(':checked')) {
                    return;
                }

                let element = $("input[name='" + item.target_value + "'], select[name='" + item.target_value + "'], textarea[name='" + item.target_value + "']");

                if (element.length === 0) {
                    return;
                }

                let elementValue = element.val();
                let values = Array.isArray(elementValue) ? elementValue : [elementValue];

                values.forEach((value) => {
                    subMerged.push({
                        field_target: item.target_value,
                        field_value: value,
                        field_return: item.return_value
                    });
                });
            });

            mergedValues[mergeName] = subMerged;
        });

        let hasMergedValues = Object.values(mergedValues).some((items) => items.length > 0);

        if (hasMergedValues) {
            postData.fields_merge = mergedValues;
        }
    }

    if (!postData.field_return && !postData.field_option_selected && !postData.fields_merge) {
        return;
    }

    axios.post(callbackField.url, postData)
    .then(function (response){
        let data = response.data;

        if (data.error) {
            classUtilitites.showAlert(data.message, "Ok", "error");
        }else{
            let result = data.result;

            Object.entries(result).forEach(([field, value]) => {
                if (field === 'option-selected' || field === 'field-merge') {
                    return;
                }

                let field_response = $(document.getElementById(field));
                let tagName = field_response.prop("tagName");

                if (tagName == 'INPUT') {
                    field_response.val(value);
                }

                if (tagName == 'P' || tagName == 'DIV') {
                    if (tagName == 'DIV' && field_response.hasClass('form-control-plaintext')) {
                        field_response.text(formatPlaintextSelectValue(value));
                    } else {
                        field_response.text(value);
                    }
                }

                if (tagName == 'SELECT') {
                    if (field_response.attr('options-full') !== undefined) {
                        field_response.html(value);
                    }else{
                        let option = '<option value="' + value + '" selected>'+ value  +'</option>';
                        field_response.append(option);
                    }
                }

                if (field_response.attr('html-full') !== undefined) {
                    field_response.html(value);
                }
            });

            // options-disabled roda primeiro: 'selected-all' (abaixo) lê as options
            // atuais do select pra marcar todas, então precisa que o filtro da
            // categoria nova já tenha sido aplicado, senão pega a lista antiga
            if (Object.prototype.hasOwnProperty.call(result, 'options-disabled')) {
                selectCallbackFieldOptionsDisabled(result['options-disabled']);
            }

            if (Object.prototype.hasOwnProperty.call(result, 'option-selected') && !isSynthetic) {
                selectCallbackFieldOptionsSelected(result['option-selected']);
            }

            if (Object.prototype.hasOwnProperty.call(result, 'field-merge')) {
                Object.entries(result['field-merge']).forEach(([name, value]) => {
                    let element = $("[name='" + name + "']");
                    let tagName = element.prop("tagName");

                    if (tagName == 'INPUT' || tagName == 'TEXTAREA') {
                        element.val(value);
                    }

                    if (tagName == 'P' || tagName == 'DIV') {
                        element.text(value);
                    }
                });
            }

            classUtilitites.createOldForm();

        }
    });
}

function selectCallbackFieldOptionsDisabled(optionsDisabled){

    if (!optionsDisabled || Object.keys(optionsDisabled).length === 0) {
        return;
    }

    Object.entries(optionsDisabled).forEach(([name, disabledValues]) => {
        let select = $('select[name="' + name + '"]');

        if (!select.length) {
            return;
        }

        // se tiver overlay load remove
        if(select.parent().find('.htmlOverlayLoading').length > 0){
            select.parent().find('.htmlOverlayLoading').removeClass('active');
            setTimeout(() => {
                select.parent().find('.htmlOverlayLoading').hide();
            }, 600);
        }

        // guarda a lista completa original na 1ª chamada, pois as próximas chamadas
        // já encontrarão o select com options removidas
        if (select.data('all-options') === undefined) {
            select.data('all-options', select.find('option').clone());
        }

        let allOptions = select.data('all-options');
        let disabled = (disabledValues || []).map(String);
        let selectedValue = select.val();
        let hadSelect2 = select.hasClass('select2-hidden-accessible');

        // destrói o select2 antes de trocar as options: só disparar 'change.select2'
        // atualiza o label exibido mas deixa o widget com o modelo interno
        // desalinhado do DOM novo (ex.: o 'x' do chip para de remover a seleção)
        if (hadSelect2) {
            select.select2('destroy');
        }

        select.empty();

        allOptions.each(function () {
            let option = $(this).clone();
            let value = String(option.val());

            // option em branco (placeholder "Selecione...") sempre permanece visível
            if (value === '' || !disabled.includes(value)) {
                select.append(option);
            }
        });

        select.val(selectedValue);

        // sem nenhuma option além do placeholder: bloqueia o select. Precisa
        // reavaliar a cada chamada (não só desabilitar), pois uma opção
        // anterior pode voltar a ficar válida quando o filtro mudar de novo.
        // Usa a mesma classe form-control-plaintext dos campos em modo "view"
        // (em vez de uma classe nova) pra ganhar de graça o visual de bloqueado
        // já validado no formulário, e trocando form-control por ela escapa da
        // regra "background-color: transparent" do form sem precisar de CSS novo
        let isBlocked = select.find('option[value!=""]').length === 0;
        select.prop('disabled', isBlocked)
            .toggleClass('form-control', !isBlocked)
            .toggleClass('form-control-plaintext', isBlocked);

        if (hadSelect2) {
            classUtilitites.formSelects();

            // o select2 esconde o <select> original (display:none) e desenha a
            // caixa visível ao lado; a classe no <select> não aparece pra
            // ninguém, precisa ir na caixa renderizada
            select.next('.select2-container').find('.select2-selection').toggleClass('form-control-plaintext', isBlocked);
        }
    });
}

// resgata (do cache 'all-options') e reinsere no select as options que podem ter
// sido removidas do DOM por um filtro anterior (selectCallbackFieldOptionsDisabled
// remove, não só desabilita); sem isso, forçar a seleção desses values falharia.
// Quando alguma option precisa ser reinserida, reinicializa o Select2 (destroy +
// formSelects) em vez de só mexer no DOM — mesmo motivo do fix em
// selectCallbackFieldOptionsDisabled: só manipular <option> deixa o widget com o
// modelo interno desalinhado do DOM novo (ex.: some interação para de funcionar).
function restoreOptionsFromCache(select, stringValues) {
    let missing = stringValues.filter((stringValue) => select.find('option[value="' + stringValue + '"]').length === 0);

    if (missing.length === 0) {
        return;
    }

    let allOptions = select.data('all-options');
    let hadSelect2 = select.hasClass('select2-hidden-accessible');

    if (hadSelect2) {
        select.select2('destroy');
    }

    missing.forEach((stringValue) => {
        let originalOption = allOptions ? allOptions.filter('[value="' + stringValue + '"]') : null;

        if (originalOption && originalOption.length) {
            select.append(originalOption.clone());
        }
    });

    if (hadSelect2) {
        classUtilitites.formSelects();
    }
}

function selectCallbackFieldOptionsSelected(optionsSelected){

    if (!optionsSelected || Object.keys(optionsSelected).length === 0) {
        return;
    }

    Object.entries(optionsSelected).forEach(([name, value]) => {
        let select = $('select[name="' + name + '"]');

        if (!select.length) {
            return;
        }

        // se tiver overlay load remove
        if(select.parent().find('.htmlOverlayLoading').length > 0){
            select.parent().find('.htmlOverlayLoading').removeClass('active');
            setTimeout(() => {
                select.parent().find('.htmlOverlayLoading').hide();
            }, 600);
        }

        let isEmpty = value === '' || value === null || value === undefined;

        // valor vazio indica que o backend quer limpar uma seleção forçada
        // anteriormente por esta mesma função; em um select multiple, '' vira
        // [''] pro jQuery e marcaria a option placeholder (value="") como um
        // chip selecionado, então limpamos com array vazio nesse caso
        if (isEmpty) {
            select.val(select.prop('multiple') ? [] : '');

            // 'change' sintético (não '.select2'): um trigger namespaced só alcança
            // handlers ligados no mesmo namespace, então nunca chegava ao listener
            // delegado de [data-callback-field] em document nem a selects sem select2;
            // com o marcador synthetic, selectCallbackField roda o ajax deste campo
            // (sincronizando os campos dependentes dele) mas não cascateia um novo
            // option-selected, evitando loop entre selects que se forçam mutuamente
            select.trigger('change', { synthetic: true });

            return;
        }

        // valor especial que instrui a marcar todas as options do select como
        // selecionadas (uso típico: select multiple); a option placeholder
        // (value="") é ignorada, senão viraria um chip vazio selecionado junto
        if (value === 'selected-all') {
            let allValues = select.find('option').map(function () {
                return $(this).val();
            }).get().filter(function (optionValue) {
                return optionValue !== '';
            });

            select.val(allValues);
            select.trigger('change', { synthetic: true });

            return;
        }

        // valor em array: marca como selecionadas todas as options cujo value
        // esteja no array (uso típico: select multiple)
        if (Array.isArray(value)) {
            let stringValues = value.map(String);

            restoreOptionsFromCache(select, stringValues);

            select.val(stringValues);
            select.trigger('change', { synthetic: true });

            return;
        }

        let stringValue = String(value);

        restoreOptionsFromCache(select, [stringValue]);

        select.val(stringValue);

        // 'change' sintético (não '.select2'): um trigger namespaced só alcança
        // handlers ligados no mesmo namespace, então nunca chegava ao listener
        // delegado de [data-callback-field] em document nem a selects sem select2;
        // com o marcador synthetic, selectCallbackField roda o ajax deste campo
        // (sincronizando os campos dependentes dele) mas não cascateia um novo
        // option-selected, evitando loop entre selects que se forçam mutuamente
        select.trigger('change', { synthetic: true });
    });
}

// true quando o select tem [data-callback-field] e, dentro do json desse
// atributo, 'fields' mapeia algum campo alvo para o marcador 'option-selected'
// (ex.: 'link[231][]' => 'option-selected') — ou seja, mudar esse select força
// a seleção de outros campos (via ProductController::callbackFieldResponse no
// back, e selectCallbackFieldOptionsSelected no front)
function callbackFieldHasOptionSelected(element){
    let callbackField = $(element).attr('data-callback-field');

    if (!callbackField) {
        return false;
    }

    let parsed;

    try {
        parsed = JSON.parse(callbackField);
    } catch (e) {
        return false;
    }

    if (!parsed.fields) {
        return false;
    }

    return Object.values(parsed.fields).includes('option-selected');
}

// intercepta o change de qualquer [data-callback-field] cujo 'fields' mapeie
// algum campo alvo para 'option-selected' — antes era um comportamento
// específico do cliente tiptoeyjoey (Tiptoeyjoey.js, removido), agora vale
// pra qualquer select nesse formato
function confirmCallbackFieldOptionSelectedChange(event, extra){
    let isSynthetic = extra != undefined && extra.synthetic;
    let isConfirmed = extra != undefined && extra.confirmed;
    let el = $(this);
    let newValue = el.val();
    let previousValue = el.data('previous-value');

    // o form só tem input[name="id"] preenchido quando o registro já existe
    // (edição); em criação o campo vem vazio ou nem existe — nesses casos não
    // há nada de vinculado pra perder, então o change segue sem interceptar
    let idField = el.closest('form').find('input[name="id"]');
    let hasFilledId = idField.length > 0 && !!idField.val();

    if (isSynthetic || isConfirmed || !hasFilledId || !callbackFieldHasOptionSelected(this)) {
        el.data('previous-value', newValue);
        return;
    }

    // handler ligado direto no elemento (fase de target do evento), então roda
    // antes do handler delegado em document (selectCallbackField) —
    // stopPropagation aqui impede o ajax de rodar enquanto o usuário não confirma
    event.stopPropagation();

    el.val(previousValue);

    Swal.fire({
        title: title_msg_alert,
        text: "Ao prosseguir, outros campos vinculados à Categoria serão atualizados automaticamente. Será necessário revisar o formulário e preencher novamente o que for preciso. Deseja continuar?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Continuar",//confirm_msg_alert,
        cancelButtonText: cancel_msg_alert,
        reverseButtons: true,
    }).then(function (result) {
        if (result.value) {
            el.val(newValue).trigger("change", { confirmed: true });
        }
    });
}

// captura o valor atual sempre que o campo ganha foco (antes de qualquer troca)
// e (re)liga o listener de 'change' direto no elemento em vez de delegado em
// document — garante que o confirm rode antes do selectCallbackField mesmo que
// o select seja recriado via ajax (replaceElement/replaceContent, utilities.js)
function checkCallbackFieldOptionSelected(){
    let el = $(this);

    el.data('previous-value', el.val());
    el.off('change.callbackFieldOptionSelected').on('change.callbackFieldOptionSelected', confirmCallbackFieldOptionSelectedChange);
}

function nameFileUpload(){

    const _parent = $(this).closest('.wrap-upload-name-js');
    let nome = this.files[0].name;
    const arquivo = this.files[0];

    if(_parent.find('.selected-file').length <= 0) {
        _parent.prepend('<div class="selected-file text-muted small mr-3"></div>');
    }

    if (!this.files.length) {
        $('.selected-file').text('');
        return;
    }

    if (nome.length > 30) {
        nome = nome.substring(0, 27) + '...';
    }

    _parent.find('.selected-file').text(arquivo ? nome : '');
    _parent.find('.selected-file').addClass('bg-light-success p-2').css('transition','all 1s ease');
    setTimeout(() => {
        _parent.find('.selected-file').removeClass('bg-light-success p-2');
    }, 1500);

}

function activeSelectMultiple(event)
{
    let el = $(this);
    let value = el.val();
    let activeSelectMultiple = JSON.parse(el.attr('data-active_select_multiple'));

    axios.request({
        method: 'post',
        url: activeSelectMultiple.url,
        data: {
            selector : el.attr('name'),
            fields: activeSelectMultiple.fields,
            value: value
        }
    }).then(function(response){
        let data = response.data;

        if (data.error === false) {
            let result = data.result;

            result.fields.forEach(function(fieldName){
                let target = $('select[name="' + fieldName + '"]');

                if (target.hasClass('select2-hidden-accessible')) {
                    target.select2('destroy');
                }

                if (result.active_multiple) {
                    target.attr('multiple', 'multiple').addClass('select');
                } else {
                    target.removeAttr('multiple').removeClass('select');
                }
            });

            classUtilitites.formSelects();
        }
    });
}

function render() {

    if ($('.auto-reload').length) {
        autoReload();
    }

    //-> SVG
    $('.svg').each(startClassSVG);

    masksInputs();
    classUtilitites.formSelects();
    classUtilitites.sortable();
    formValidade();
    checkNotifications();
    classUtilitites.createOldForm();
    SicknessWizard.init();
    Chats.init();
    Chat.init();
    // ChatsV3.init();
    GeoLocation.init();
    dropRangeFilter();
    dropDownTextDinamic();
    checkEtapaToFooterFix();
    Lia.init();
    RouletteIntervalStartAuto();
    headerShowResultFilters();
    classUtilitites.sidebarInfoTabs();
    classUtilitites.formInfoLoad('product');

    let formToOrder = document.querySelector('#form-auto-reorder');
    if (formToOrder) {
        classUtilitites.orderFieldsWrap();
        if(document.querySelector('.elmToClone')) {
            classUtilitites.cloneElementToArea('.elmToClone','area-input-clonned');
        }
    }
    // setInterval(() => {
    //     checkNotifications();
    // }, 30000);


    $('.processAjax').keypress(function (e) {
        var key = e.which;
        if (key == 13)  // the enter key code
        {
            classUtilitites.processAjax($(this));
        }
    });

    $('[data-toggle="tooltip"], [data-toggle-second="tooltip"]').tooltip();

    if ($('input[name="contact_field"]').length > 0) {
        contactField()
    }

    // confirm quando deletar algum select multiple de coleção (abas em produtos)
    $(document).on('select2:unselecting', 'select[name="link[236][]"]', function (e) {

        e.preventDefault();

        const $select = $(e.target);
        const item = e.params.args.data;

        Swal.fire({
            title: "Removendo...",
            text: `Tem certeza que deseja remover "${item.text}"?`,
            icon: "warning",
            showCancelButton: true,
            // confirmButtonColor: "#c1b7ff",
            // cancelButtonColor: "#f64e60",
            confirmButtonText: "Sim, remover",
            cancelButtonText: "Cancelar"
        }).then((result) => {

            if (!result.isConfirmed) {
                return;
            }

            // Pega os valores atualmente selecionados
            let values = $select.val() || [];

            // Remove o item que foi clicado no X
            values = values.filter(value => value != item.id);

            // Atualiza o Select2
            $select
                .val(values)
                .trigger('change');

        });

    });

    $(document).on('change', 'input[name="contact_field"]', contactField);

/*     $(document).on("click", ".trigger-emoji", function(e) {
        const target = $($(this).data('target'));
        if (window.matchMedia("(pointer: coarse)").matches) {
            e.preventDefault();
            target.focus();
            return;
        }
        e.preventDefault();
        target.emojiPicker('toggle');
    }); */

    $(document).on("click", ".btn-opp-filter", btnOppFilter);
    $(document).on("click", ".btn-notif", clearPulseNotifications);
    $(document).on("click", ".autocomplete-field", autocompleteField);
    $(document).on("click", ".bt-notifications", btNotifications);
    $(document).on("click", ".bt-check-notifications", btCheckNotifications);
    $(document).on("click", ".remove-selected-composition", removeSelectedComposition);
    $(document).on("click", ".bt-check-element", checkElement);
    $(document).on("click", ".bt-add-element", addElement);
    $(document).on("click", ".bt-remove-line", classUtilitites.removeLine);
    $(document).on("click", ".bt-nav-tab", classUtilitites.changeTab);
    $(document).on("click", ".bt-ajax", ajaxFunction);
    $(document).on("change", "[data-callback-field]", selectCallbackField);
    $(document).on("focus", "select[data-callback-field]", checkCallbackFieldOptionSelected);
    $(document).on("change", ".elm-upload-to-name-file", nameFileUpload);
    $(document).on("click", ".input-show-password", function(){
        const input = $(this).closest('.input-group').find('input');
        const icon = $(this).closest('.input-group').find('i');//this.querySelector("i");

        if (input.attr('type') === "password") {
            input.attr('type',"text");
            icon.removeClass("fa-eye");
            icon.addClass("fa-eye-slash");
        } else {
            input.attr('type',"password");
            icon.removeClass("fa-eye-slash");
            icon.addClass("fa-eye");
        }
    });

    if ($("select[data-callback-field]").length > 0) {
        $("select[data-callback-field]").each(function(){
            let element = $(this);
            let value = element.val();

            if (value.length > 0) {
                // sintético: dispara no carregamento da página só pra sincronizar o
                // select2 (ex.: options-disabled já herdadas do value renderizado pelo
                // Blade), não deve rodar o ajax de options-disabled/option-selected como
                // se fosse uma mudança real do usuário — selectCallbackField ignora isso
                element.trigger("change", { synthetic: true });
            }
        });
    }

    if ($('input[data-callback-field]').length > 0) {
        $('input[data-callback-field]').each(function(){
            let element = $(this);
            let value = element.val();

            if (value.length > 0) {
                element.trigger("change");
            }
        });
    }

    // select sem ajax
    $(document).on('change', "[data-callback-field-no-ajax]", function(){
        $(this).closest('form').submit();
        // var form = $(this).closest('form');
        // form.attr('action', window.location.search);
        // form.submit();

    });

    $(document).on("keyup", ".field-keyup", function () {
        let timer;
        let enviado = false;
        clearTimeout(timer);
        var element = $(this);

        // se já enviou, só libera novamente quando começar a digitar de novo
        if (enviado) {
            enviado = false;
        }

        timer = setTimeout(function () {
            if (!enviado) {
                enviado = true; // marca como enviado até nova digitação
                ajaxFunction(Event, element)
            }
        }, 1500);
    });
    $(document).on("click", "#copyClipboard", copyClipboard);
    $(document).on("click", ".copyClipboardHidden", copyClipboardHidden);
    $(document).on("click", ".bt-change-visibility-ajax", changeVisibilityAjax);
    $(document).on("click", ".bt-change-visibility", changeVisibility);
    $(document).on("click", ".bt-hide-element", btHideElement);
    $(document).on("click", ".bt-confirm", confirmFunction);
    $(document).on("click", ".bt-confirm-two-options", confirmFunctionTwoOptions);
    $(document).on("click", ".bt-confirm-text", confirmTextFunction);
    $(document).on("click", ".bt-confirm-select", confirmSelectFunction);
    $(document).on("click", ".bt-confirm-mult", confirmMultiFieldFunction);
    $(document).on("click", ".bt-nationality", changeFormNationality);
    $(document).on("click", ".bt-enterprise", changeFormEnterprise);
    $(document).on("submit", ".form-ajax", submitAjax);
    $(document).on("submit", ".form-ajax-recepcionista", submitAjaxRecepcionista);
    $(document).on("submit", ".form-ajax-recepcionista-2", submitAjaxRecepcionista2);
    initConfirmOnSubmit();
    // $(document).on("click", ".wizard-step", showWizardAba);
    $(document).on("change", "input[name=radioCheckIndicacao]", checkIndication);
    $(document).on("change", "input[name=radioCheckCorretor]", checkIdCorretorInReception);
    $(document).on("change", "input[name=radioCheckRoleta]", checkRouletteBoolean);
    $(document).on("click", "[data-modal]", showModal);
    $(document).on("click", "[data-iframe]", showIframe);
    $(document).on("click", ".page-btn[data-ajax]", changePage);
    $(document).on("keyup", ".mask-zipcode", searchZipcode);
    $(document).on("change", "#id_order_packing", getAditionalOrders);
    $(document).on("change", ".selectCategory", checkCategorySub);
    $(document).on("change", ".selectAction", selectAction);
    $(document).on("change", ".changeSubmit", changeSubmit);
    $(document).on("change", ".selectCopy", selectCopy);
    $(document).on("click", ".btCopy", btCopy);
    $(document).on("change", ".elementChangeHideShow", elementChangeHideShow);
    $(document).on("click", "a[data-export]", reportExport);
    $(document).on("click", ".copyText", copyText);
    $(document).on("change", ".checkChange", checkChange);
    $(document).on("change", ".elementChange", elementChange);
    $(document).on("click", ".before-check", beforeCheck);
    $(document).on("change", ".select-info .element-form", formSelectInfo);
    $(document).on("click", ".change-element-toggle", elCustomToggle);
    $(document).on("click", ".call-loader-js", loaderOnNavigate);
    $(document).on("submit", "form", loaderOnFormSubmit);
    $(document).on("click", ".change-tag-cloud", selectTagCloud);
    $(document).on("click", ".hf-clear-this-input", clearThisFilter);
    $(document).on("focusout", '.check-slug[name="slug"]', function () {
        let element = $(this);
        let value = element.val();
        let href = element.data('href');
        let button = element.closest('form').find('button');

        button.text('Checando slug').prop("disabled", true);

        Axios.post(href, { slug: value })
            .then(function (response) {
                let data = response.data;

                if (data.error === false) {
                    element.val(data.result.slug)
                    button.text('Criar').prop("disabled", false);
                }
            });
    });
    $(document).on("change", ".input-change", inputChange);
    $(document).on("change", ".clear-target-on-check", clearTargetOnCheck);
    $(document).on("click", ".btnSearchCategory", searchCategory);
    $(document).on('change', '.attach-category-product', attachCategoryProduct);
    $(document).on('click', '.save-catalog', saveCatalog);
    $(document).on('click', '#toggleAllAccordions', function(){
        let _this = $(this);
        if(_this.attr('data-status') == 1){
            $('.collapse').addClass('show');
            _this.attr('data-status', 0);
        } else {
            $('.collapse').removeClass('show');
            _this.attr('data-status', 1);
        }
    });
    $(document).on('change', 'select[data-active_select_multiple]', activeSelectMultiple);

    // accordions com links na aba nao devem funcionar
    $(document).on('click', '.accordion a[data-modal]', function(){
        return false;
    });

    if ($('.cardAutoLoad').length > 0) {
        cardAutoLoad();
    }

    /* $(document).on('keyup', '.searchItem', function(e){
        e.preventDefault();
        const el = $(this);

        var parentResults = el.closest('.wrap-results-search');
        var elmToFind = el.attr('data-find');
        var input = el;//document.getElementById("searchItem");
        var conta = el.val();//$("#searchItem").val();
        var nodes = $(elmToFind);
        if(conta.length >= 3) {
            var filter = input.val().toLowerCase();
            for (let i = 0; i < nodes.length; i++) {
                if (classUtilitites.tiraAcentos(nodes[i].innerText).includes(classUtilitites.tiraAcentos(filter))) {
                    $(nodes[i]).show();
                    parentResults.find('.search-not-found').hide();
                } else {
                    $(nodes[i]).hide();
                    if($(elmToFind+':visible').length <= 0) {
                        parentResults.find('.search-not-found').show();
                    }
                }
            }
        } else {
            nodes.show();
        }
    }); */

    /******************************************************* */
    // busca proposal product detail
    $(document).on("keyup", ".searchItemTables", function (e) {
        e.preventDefault();
        const el = $(this);
        const tabela = el.attr("data-find");
        const parentResults = el.closest(".wrap-results-search");

        console.log('find:',$(tabela + " td:not(.no-filter):contains-ci('" + el.val() + "')").parent("tr").length);

        if($(tabela + " td:not(.no-filter):contains-ci('" + el.val() + "')").parent("tr").length < 1) {
          console.log("nao tem");
          $(tabela + ' tr').hide();
          parentResults.find(".search-not-found").show();
        } else {
            parentResults.find(".search-not-found").hide();
          $(tabela + ' tr').hide();
                $(tabela + " td:not(.no-filter):contains-ci('" + el.val() + "')")
            .closest("tr")
            .show();
        }
      });

    $.extend($.expr[":"], {
        "contains-ci": function (elem, i, match, array) {
        return (
            (elem.textContent || elem.innerText || $(elem).text() || "")
            .toLowerCase()
            .indexOf((match[3] || "").toLowerCase()) >= 0
        );
        }
    });
    /******************************************************* */

    if ($('input[name="person"]:checked').length > 0) {
        $('input[name="person"]:checked').trigger('click');
    }

    if ($('#countdownReload').length > 0) {
        countdown($('#countdownReload').data('time'));
    }

    if ($('.dropzone').length > 0) {

        $('.dropzone').each(function (index, value) {
            // set the dropzone container id
            var number = $(value).data('number');
            var id = '#kt_dropzone_' + number;

            // set the preview element template
            var previewNode = $(id + " .dropzone-item");
            previewNode.id = "";
            var previewTemplate = previewNode.parent('.dropzone-items').html();
            previewNode.remove();

            window['myDropzone' + number] = new Dropzone(id, { // Make the whole body a dropzone
                url: $(id).data('url'), // Set the url for your upload script location
                parallelUploads: 1,
                paramName: 'files[]',
                maxFilesize: 50, // Max filesize in MB
                previewTemplate: previewTemplate,
                previewsContainer: id + " .dropzone-items", // Define the container to display the previews
                clickable: id + " .dropzone-select", // Define the element that should be used as click trigger to select files.,
                headers: {
                    'X-CSRF-TOKEN': CSRF_TOKEN
                }
            });

            window['myDropzone' + number].on("addedfile", function (file) {
                // Hookup the start button
                $(document).find(id + ' .dropzone-item').css('display', '');
            });

            // Update the total progress bar
            window['myDropzone' + number].on("totaluploadprogress", function (progress) {
                $(id + " .progress-bar").css('width', progress + "%");
            });

            window['myDropzone' + number].on("sending", function (file) {
                // Show the total progress bar when upload starts
                $(id + " .progress-bar").css('opacity', "1");
            });

            // Hide the total progress bar when nothing's uploading anymore
            window['myDropzone' + number].on("complete", function (progress) {
                const responseAjax = JSON.parse(progress.xhr.response);

                var thisProgressBar = id + " .dz-complete";
                setTimeout(function () {
                    $(thisProgressBar + " .progress-bar, " + thisProgressBar + " .progress").css('opacity', '0');
                }, 300);

                if (responseAjax.error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: responseAjax.message,
                      });
                } else {
                    $('.alert').slideToggle();
                    setTimeout(() => {
                        $('.alert').slideToggle();
                    }, 3000);
                }
            });
        });

    }

    if ($("#select-filter-for-period").length > 0) {
        $("#select-filter-for-period").on('change', function () {
            if ($(this).val() === "period" || $(this).val() === "period_create") {
                $("#row-filters-date-range").css('display', 'flex');
                return false;
            } else {
                $("#row-filters-date-range").hide();

            }
        });
    }

    $(document).on('click', '.toggle-export', function () {
        let element = $(this);
        let card = element.closest('.card');
        let cardBody = card.find('.card-body');

        cardBody.slideToggle();
    });

    var url_current = $('.menu-nav').data('url_current');
    $('.menu-nav .menu-link').each(function () {
        var element = $(this);

        if (url_current == element.attr('href')) {
            element.closest('li').addClass('menu-item-active');
            if (element.closest('.menu-subnav').length > 0) {
                element.closest('.menu-subnav').closest('li').addClass('menu-item-open menu-item-here');
            }
        }
    });


    // funcao get pata duplicar elementos
    $(document).on('click', '.js_click-1x', function (e) {

        //e.preventDefault();
        let _this = $(this);
        if (_this.hasClass('disabled')) return false;
        _this.addClass('disabled');
        loaderOnNavigate.call(this, e);

    })

    // Voltar do navegador (bfcache): libera os links que ficaram marcados como já clicados
    window.addEventListener('pageshow', (e) => e.persisted && $('.js_click-1x.disabled').removeClass('disabled'));

    $(document).on('submit', '.confirm-submit', function (element) {
        const form = $(this);

        if (form.attr('data-confirmed') !== 'true') {
            element.preventDefault();

            const title = form.data('confirm_title') ?? "Tem certeza que deseja continuar com a ação?";

            Swal.fire({
                title: "Tem certeza?",
                text: title,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Sim",
                cancelButtonText: 'Cancelar',
                closeOnConfirm: false
            }).then((result) => {
                if (result.isConfirmed) {
                    form.attr('data-confirmed', true);
                    form.find('.section-buttom').slideToggle();
                    form.trigger('submit');
                }
            });

        }



    });

    if ($('.execute-ajax-on-load').length > 0) {

        $('.execute-ajax-on-load').each(executeAjaxOnLoad);

    }

    Datepicker.init();
    LinkChecker.init();
    ExportData.init();
    Notification.init();

}

$(".cancelContract").click(function () {

    var id = $(this).attr("data-id");

    var link = '/orders/cancel-contract/' + id;

    $.ajax({
        type: "GET",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: link,
        dataType: "json",
        success: function (data) {
            if (data.status == true) {
                classUtilitites.showAlert("Contrato cancelado com sucesso!", "Ok", "success");

                setTimeout(function () {
                    location.reload();
                }, 1000);
            } else {
                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        }
    });
});

$(".resendContract").click(function () {

    var id = $(this).attr("data-id");

    var link = '/orders/resend-contract/' + id;

    $.ajax({
        type: "GET",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: link,
        dataType: "json",
        success: function (data) {
            if (data.status == true) {
                classUtilitites.showAlert("Contrato reenviado com sucesso!", "Ok", "success");

                setTimeout(function () {
                    location.reload();
                }, 1000);
            } else {
                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        },
    });
});

$(".sendContract").click(function () {

    var id = $(this).attr("data-id");

    var link = '/orders/send-contract/' + id;

    $.ajax({
        type: "GET",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: link,
        dataType: "json",
        success: function (data) {
            if (data.status == true) {
                classUtilitites.showAlert("Contrato enviado com sucesso!", "Ok", "success");

                setTimeout(function () {
                    location.reload();
                }, 1000);

            } else {
                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        }
    });
});


$(".download_document").click(function () {

    var id = $(this).attr("data-id");

    var link = '/orders/downloadContract/' + id;

    $.ajax({
        type: "GET",
        headers: {
            'X-CSRF-TOKEN': CSRF_TOKEN
        },
        url: link,
        dataType: "json",
        success: function (data) {

            console.log(data.status);

            if (data.status == true) {
                classUtilitites.showAlert("O download será iniciado!", "Ok", "success");

                window.open(data.url, '_blank');

                setTimeout(function () {
                    location.reload();
                }, 1000);

            } else {
                classUtilitites.showAlert("Erro de comunicação, por favor, recarregue a página", "Ok");

                if (APP_DEBUG != "ON") {
                    setTimeout(function () {
                        location.reload();
                    }, 1000);
                }
            }
        }
    });
});

// Abre o overlay só quando o clique realmente navega; o Loader (pageshow/watchdog) cobre o resto.
function loaderOnNavigate(e) {
    const link = this.closest('a');

    if (!link || e.ctrlKey || e.metaKey || e.shiftKey || e.which === 2) return;

    const href = link.getAttribute('href') || '';
    const navigates = href !== '' && !/^(#|javascript:)/i.test(href)
        && link.target !== '_blank'
        && !link.hasAttribute('download')
        && !link.hasAttribute('data-export')
        && !link.hasAttribute('data-ajax');

    if (navigates) Loader.show();
}

// Botão de filtro: abre só depois que o navegador aceitou o submit (required etc.).
function loaderOnFormSubmit() {
    if ($(this).find('.call-loader-js').length > 0) Loader.show();
}


// function v3 date in oportunities
function dropRangeFilter(){

    // cria botão de flag
    /* $(document).on('click', "[data-range-key=Personalizado]", function(){

        let newButton = document.createElement('button');
        newButton.classList.add("btFlagInteraction");
        newButton.classList.add("btn");
        newButton.classList.add("btn-sm");
        newButton.classList.add("mr-2");
        newButton.classList.add("btn-light");
        newButton.id="btFlagInteraction";
        newButton.textContent ="Interação";
        newButton.value='';

        $('.daterangepicker.show-ranges').find('.drp-buttons').prepend(newButton)
    }) */

    $(document).on('click', '#btFlagInteraction', function(){
        console.log('botao flag clicado');
    })

    moment.locale('pt-br');

    if ($('#kt_dashboard_daterangepicker').length == 0) {
        return;
    }

    var picker          = $('#kt_dashboard_daterangepicker');
    var inputFilterVal  = $("#input-change-funil").val();
    var start           = moment();
    var end             = moment();


    // carregamento da pagina
    switch (inputFilterVal) {
        case 'today':
            start           = moment();
            end             = moment();
            break;
        case 'yesterday':
            start           = moment().subtract(1, 'days');
            end             = moment().subtract(1, 'days');
            break;
        case 'week':
            start           = moment().subtract(6, 'days');
            end             = moment();
            break;
        case 'late30days':
            start           = moment().subtract(29, 'days');
            end             = moment();
            break;
        case 'nextweek':
            start           = moment();
            end             = moment().add(6, 'days');
            break;
        case 'next30days':
            start           = moment();
            end             = moment().add(29, 'days');
            break;
        case 'thisweek':
            start           = moment().startOf('isoWeek');
            end             = moment().endOf('isoWeek');
            break;
        case 'month':
            start           = moment().startOf('month');
            end             = moment().endOf('month');
            break;
        case 'lastmonth':
            start           = moment().subtract(1, 'month').startOf('month');
            end             = moment().subtract(1, 'month').endOf('month');
            break;

        default:
            start           = moment();
            end             = moment('1990-01-01');
            break;
    }

    let filtersRanges = '';

    if($('#kt_dashboard_daterangepicker').hasClass('kt_dashboard_daterangepicker--BI')){
        filtersRanges = {
            'Hoje': [moment(), moment()],
            //'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Esta Semana': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
            'Última Semana': [moment().subtract(1, 'weeks').startOf('isoWeek'), moment().subtract(1, 'weeks').endOf('isoWeek')],
            // 'Últimos 7 Dias': [moment().subtract(6, 'days'), moment()],
            // 'Últimos 30 Dias': [moment().subtract(29, 'days'), moment()],
            'Este Mês': [moment().startOf('month'), moment().endOf('month')],
            'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
    }else if($('#kt_dashboard_daterangepicker').hasClass('kt_dashboard_daterangepicker--ttj-ticket')){
        filtersRanges = {
            'Todos': [moment(), moment('1990-01-01')],
            'Hoje': [moment(), moment()],
            'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Últimos 7 Dias': [moment().subtract(6, 'days'), moment()],
            'Últimos 30 Dias': [moment().subtract(29, 'days'), moment()],
            // 'Próximos 7 Dias': [moment(), moment().add(6, 'days')],
            // 'Próximos 30 Dias': [moment(),moment().add(29, 'days')],
            // 'Última Semana': [moment().subtract(1, 'weeks').startOf('isoWeek'), moment().subtract(1, 'weeks').endOf('isoWeek')],
            // 'Esta Semana': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
            'Este Mês': [moment().startOf('month'), moment().endOf('month')],
            'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
    }else{
        filtersRanges = {
            'Todos': [moment(), moment('1990-01-01')],
            'Hoje': [moment(), moment()],
            'Ontem': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
            'Últimos 7 Dias': [moment().subtract(6, 'days'), moment()],
            'Últimos 30 Dias': [moment().subtract(29, 'days'), moment()],
            'Próximos 7 Dias': [moment(), moment().add(6, 'days')],
            'Próximos 30 Dias': [moment(),moment().add(29, 'days')],
            // 'Última Semana': [moment().subtract(1, 'weeks').startOf('isoWeek'), moment().subtract(1, 'weeks').endOf('isoWeek')],
            // 'Esta Semana': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
            'Este Mês': [moment().startOf('month'), moment().endOf('month')],
            'Último Mês': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
        }
    }

    picker.daterangepicker({
        // cancelClass: 'btn-light-primary',
        // applyClass: 'btn-primary',
        // direction: KTUtil.isRTL(),
        // showDropdowns: true,
        // linkedCalendars: false,
        // showCustomRangeLabel: true,
        // startDate: "01/01/1990",
        // endDate: moment(),
        // ranges: filtersRanges,
        direction: KTUtil.isRTL(),
        startDate: start,
        endDate: end,
        opens: 'left',
        applyClass: 'btn-primary',
        cancelClass: 'btn-light-primary',
        ranges: filtersRanges,
        showDropdowns: true,
        // ranges: filtersRanges,
        "locale": {
            "format": 'DD/MM/YYYY hh:mm A',
            "separator": " - ",
            "applyLabel": "Aplicar",
            "cancelLabel": "Cancelar",
            "fromLabel": "De",
            "toLabel": "Para",
            "customRangeLabel": "Personalizado",
            "weekLabel": "S",
            "daysOfWeek": [
                "Dom",
                "Seg",
                "Ter",
                "Qua",
                "Qui",
                "Sex",
                "Sab"
            ],
            "monthNames": [
                "Janeiro",
                "Fevereiro",
                "Março",
                "Abril",
                "Maio",
                "Junho",
                "Julho",
                "Agosto",
                "Setembro",
                "Outubro",
                "Novembro",
                "Dezembro"
            ],
            "firstDay": 0
        },
        "parentEl": "body",
    }, cb);

    if($('#kt_dashboard_daterangepicker').hasClass('kt_dashboard_daterangepicker--BI')){

        const defaultTextPeriod = $('#input-change-funil').attr('data-text-period');

        $('#kt_dashboard_daterangepicker_title').html(defaultTextPeriod ? defaultTextPeriod : 'Selecione um Período');
        $('#kt_dashboard_daterangepicker_date').html('');
    }

    function cb(start, end, label) {

        var title   = '';
        var range   = '';
        var pers    = [];
        var dateFormatedStart    = moment();
        var dateFormatedEnd    = moment();

        // FILTRO PARA SUBMIT (BI)
        if($('#kt_dashboard_daterangepicker').hasClass('kt_dashboard_daterangepicker--BI')){
            title = label;
            if (label == 'Hoje') {
                dateFormatedStart   = moment().format('YYYY-MM-DD');
                dateFormatedEnd     = moment().format('YYYY-MM-DD');
            } else if (label == 'Ontem') {
                title = label;
                dateFormatedStart   = moment().subtract(1, 'day').format('YYYY-MM-DD');
                dateFormatedEnd     = moment().subtract(1, 'day').format('YYYY-MM-DD');
            } else if (label == 'Últimos 7 Dias') {
                dateFormatedStart   = moment().subtract(6, 'day').format('YYYY-MM-DD');
                dateFormatedEnd     = moment().format('YYYY-MM-DD');
            } else if (label == 'Últimos 30 Dias') {
                dateFormatedStart   = moment().subtract(29, 'day').format('YYYY-MM-DD');
                dateFormatedEnd     = moment().format('YYYY-MM-DD');
            } else if (label == 'Próximos 7 Dias') {
                dateFormatedStart   = moment().add(6, 'day').format('YYYY-MM-DD');
                dateFormatedEnd     = moment().format('YYYY-MM-DD');
            } else if (label == 'Próximos 30 Dias') {
                dateFormatedStart   = moment().add(29, 'day').format('YYYY-MM-DD');
                dateFormatedEnd     = moment().format('YYYY-MM-DD');
            } else if (label == 'Última Semana') {
                dateFormatedStart   = moment().subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
                dateFormatedEnd     = moment().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
            } else if (label == 'Esta Semana') {
                dateFormatedStart   = moment().startOf('isoWeek').format('YYYY-MM-DD');
                dateFormatedEnd     = moment().endOf('isoWeek').format('YYYY-MM-DD');
            } else if (label == 'Este Mês') {
                dateFormatedStart   = moment().startOf('month').format('YYYY-MM-DD');
                dateFormatedEnd     = moment().endOf('month').format('YYYY-MM-DD');
            } else if (label == 'Último Mês') {
                dateFormatedStart   = moment().subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
                dateFormatedEnd     = moment().subtract(1, 'month').endOf('month').format('YYYY-MM-DD');
            } else if (label == 'Personalizado') {
                range = '';//start.format('MMM D') + ' - ' + end.format('MMM D');
                pers  = [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')];
                dateFormatedStart = pers[0];
                dateFormatedEnd = pers[1];
                title = `${start.format('DD/MM/YYYY')} à ${end.format('DD/MM/YYYY')}`;
            } else {
                // range = start.format('MMM D') + ' - ' + end.format('MMM D');
                console.log('Nenhum filtro de data correto selecionado');
            }

        // FILTRO AJAX (Oprtunidades)
        } else {

            if ((end - start) < 100 || label == 'Hoje') {
                title = 'Hoje:';
                range = start.format('MMM D');
            } else if (label == 'Ontem') {
                title = 'Ontem:';
                range = start.format('MMM D');
            } else if (label == 'Personalizado') {
                title = '';
                range = start.format('MMM D') + ' - ' + end.format('MMM D');
                pers  = [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')];
                $("#dtInitial").val(pers[0]);
                $("#dtEnd").val(pers[1]);
            } else {
                range = start.format('MMM D') + ' - ' + end.format('MMM D');
            }
        }

        // console.log(start, end, label, range, pers);

        $('#kt_dashboard_daterangepicker_date').html(range);
        $('#kt_dashboard_daterangepicker_title').html(title);

        // submit
        var typeFilterDate = '';
        let dateFormat = '';
        if(label == 'Hoje') {
            typeFilterDate = 'today';
        }else if(label == 'Ontem'){
            typeFilterDate = 'yesterday';
        }else if(label == 'Últimos 7 Dias'){
            typeFilterDate = 'week';
        }else if(label == 'Últimos 30 Dias'){
            typeFilterDate = 'late30days';
        }else if(label == 'Próximos 7 Dias'){
            typeFilterDate = 'nextweek';
        }else if(label == 'Próximos 30 Dias'){
            typeFilterDate = 'next30days';
        }else if(label == 'Este Mês'){
            typeFilterDate = 'month';
        }else if(label == 'Último Mês'){
            typeFilterDate = 'lastmonth';
        }else if(label == 'Personalizado'){
            typeFilterDate = $("#input-change-funil[data-dp-custom-value]").length > 0 ? $("#input-change-funil").attr('data-dp-custom-value') : 'period_create';
        }else if(label == ''){
            typeFilterDate = '';
        }

        $("#input-change-funil").val(typeFilterDate);

        // verifica se é BI
        if($('#kt_dashboard_daterangepicker').hasClass('kt_dashboard_daterangepicker--BI')){

            console.log('__________________________________________________');
            console.log(label);
            console.log('start = '+dateFormatedStart);
            console.log('end = '+dateFormatedEnd);

            $("#dtInitial").val(dateFormatedStart);
            $("#dtEnd").val(dateFormatedEnd);

        } else {
            if(typeFilterDate != ""){
                setTimeout(() => {
                    //console.log('looping?');
                    // submitAjax();
                    if(label != '') {
                        ajaxGetFilters("#input-change-funil");
                    }
                }, 200);
            }
        }

    }
    //cb(start, end, '');

    // Oportunidade, nao inicia com data default, então não se aplica isso
    // if(inputFilterVal != 'period_create') {
    //     cb(start, end);
    // }
}

function btnOppFilter () {
    $($(this).attr('data-target')).val($(this).attr('data-val'));

    ajaxGetFilters($(this));
}

function dropDownTextDinamic () {
    let elmDrop = ".drop-text-dinamic";
    $(elmDrop).each(function() {
        const _this = $(this);
        _this.parent().find('li').on('click', function(){
            let thisText        = $(this).text();
            let thisColor       = $(this).attr('data-color');
            let thisCategory    = $(this).attr('data-idCat');
            _this.text(thisText);
            $("#input-change-category").val(thisCategory);
            _this.removeClass('btn-light btn-light-primary btn-light-warning btn-light-danger btn-light-success').addClass(thisColor);
            ajaxGetFilters($(this));
        })

    })
}

function ajaxGetFilters (el) {

    startLoadingGlobal();

    // $(el).closest('form').trigger('submit');
    $(el).closest('form')[0].submit();

}

function selectTagCloud(){

    let elm         = $(this);
    const input     = $("#tagscloud");
    let tags = [];

    elm.toggleClass('active');

    if(elm.hasClass('active')) {
        elm.removeClass('btn-light').addClass('btn-success');
    } else {
        elm.removeClass('btn-success').addClass('btn-light');
    }

    $(".change-tag-cloud.active").each(function(i, el) {
        // console.log( $(el).attr('data-id') );
        tags.push($(el).attr('data-id'))
    });

    input.val(tags);

}

// loader PAGE FULL on
function startLoadingGlobal (){
    KTApp.blockPage({
		overlayColor: '#000000',
		state: 'dark',
		message: 'Processando...'
	});
}

// $(document).on('click',['call-loading'], startLoadingGlobal);

// loader PAGE FULL off
function endLoadingGlobal (){
    KTApp.unblockPage();
}

function startLoadingParent (){
    KTApp.block('.kt_loading', {
		overlayColor: '#000000',
		state: 'secondary',
		message: 'Processando...'
	});
}

function endLoadingParent (){
    KTApp.unblock('.kt_loading');
}

function RouletteIntervalStartAuto () {
    if($('#choose-toggle-interval-roulette').length > 0) {
        const radioValue = $('#choose-toggle-interval-roulette input[name="mode"]:checked').val();
        if( radioValue == 3 ) {
            $("#toggle-interval-roulette").slideDown();
        } else {
            $("#toggle-interval-roulette").slideUp();
        }
    }
}

function scrollAnchor (e) {
    let _this  = $(e.currentTarget);
    let goTo = _this.attr('data-scroll_anchor');

    let elmScroll = _this.is('[data-scroll_elm]') ? _this.attr('data-scroll_elm') : 'html, body';
    console.log(elmScroll);

    if(elmScroll == '.modal-content-scrollable-custom'){
        $('#acc-modal-comment').collapse('show');
    }

    $(elmScroll).animate({
        scrollTop: $(goTo).offset().top
      }, 800);
}

$(document).on('click', '[data-scroll_anchor]', scrollAnchor);

$(document).on('change', '.filter-advanced-unic-option .select2, .filter-advanced-unic-option select', function(){
    // console.log($(this).val());
    ajaxGetFilters($(this));
})

// trigger suporte chat witch button customized ONE in top header side of name
$(document).on('click', '#bt-header-trigger-suport-api', function(){
    if( $('div[title="Botão de live chat"]').length > 0 ) {
        $('div[title="Botão de live chat"]').trigger('click');
    }
    if( $('div[title="Botão de contate-nos"]').length > 0 ) {
        $('div[title="Botão de contate-nos"]').trigger('click');
    }
})

$('#input-switch-discarded').on('switchChange.bootstrapSwitch', function (event, state) {
    $("#discarded").val(state == true ? 1 : '');
});

// roulette -> exibir ou não o intervalo de horario em detail
$(document).on('change', '#choose-toggle-interval-roulette input[name=mode]', function() {
    RouletteIntervalStartAuto();
});

// close menuside mobile
$(document).on('click', '#kt_aside_mobile_toggle-c', function(){
    $("#kt_aside").toggleClass('aside-on');
});

$(document).on('click', '#kt_aside_toggle-mobile', function(){
    $("#kt_aside").toggleClass('aside-on');
});

// exibe resultado de filtros em produtos
function headerShowResultFilters () {

    const wrapResultJsFilter        = "#wrap-hf-result";
    const wrapGetNameInputResults   = "#header-get-result-filters";
    const resultsFiltersIn          = "#header-result-filter-by";

    if($(wrapGetNameInputResults).length <= 0) return;

    // busca todas categorias para comparar o GET do PHP
    $.ajax({
        type: "POST",
        url: $(wrapGetNameInputResults).attr('data-url'),
        dataType: 'json'
    }).done(function(data){
        comparaDados(data)
    });

    // console.log(window.location.search);

    function comparaDados(obj){

        // console.log(obj);

        let namesFilters = '';
        $(wrapGetNameInputResults).find('.hrfb--field').each(function(i,e){

            let fName               = $(e).attr('data-name');
            let fValue               = $(e).attr('data-value');
            let InputName           = $(`[name="${fName}"]`);
            let inputValue          = '';
            let inputPlaceholder    = "";

            // console.log(fName);
            inputValue              = fValue;

            // se nao tem o campo, ele procura nas categorias do ajax
            if(InputName.length > 0) {
                if(InputName[0].tagName == 'SELECT' ){
                    inputPlaceholder = InputName.attr('data-placeholder');
                    inputValue = InputName.select2('data')[0].text;
                }else{
                    inputPlaceholder    = InputName.attr('placeholder');
                }
            }else{
                inputPlaceholder    = obj[fName].title;
            }


            namesFilters += "<span class='label label-lg label-rounded px-2 py-1 mx-1 mb-1 w-auto h-auto'>"+ inputPlaceholder +": <b class='ml-1'>"+ inputValue +"</b><button class='ml-2 btn btn-ico p-0 w-auto hf-clear-this-input' data-name='"+fName+"'><i class='d-flex fas fa-times icon-sm'></i></button></span>";

            /* if(InputName.length > 0) {

                inputValue = InputName.val();

                if(InputName[0].tagName == 'SELECT' ){
                    inputPlaceholder = 'data-placeholder';
                    inputValue = InputName.select2('data')[0].text;
                }

                namesFilters += "<span class='label label-lg label-rounded px-2 py-1 mx-1 mb-1 w-auto h-auto'>"+ inputPlaceholder +": <b class='ml-1'>"+ inputValue +"</b><button class='ml-2 btn btn-ico p-0 w-auto'><i class='d-flex fas fa-times icon-sm'></i></button></span>";
            } */


        });
        // console.log($(e).length);
        if( $(wrapGetNameInputResults).find('.hrfb--field').length > 0 ){
            $(wrapResultJsFilter).addClass('d-flex').show();
            $(resultsFiltersIn).html(namesFilters.toLowerCase());
        }
    }
}

function clearThisFilter(e){
    e.preventDefault();
    let _this = $(e.currentTarget);
    let dataName = _this.attr('data-name');
    let inputClear = $(`[name="${dataName}"]`);

    inputClear.val('');
    _this.parent().fadeOut(300);

    let form = _this.closest('form');
    // form.submit();

    // console.log($('#header-result-filter-by').find('>span').length);

    // if( $('#header-result-filter-by').find('>span').length <= 1 ){
    //     form.attr('action', window.location.pathname);
    // }

    form.submit();
}

// function para tirar campo "etapas" e adiciona-lo ao footer flutuante em PINS
function checkEtapaToFooterFix() {
    if (document.querySelector('.elmToClone') && document.querySelector('#area-input-clonned')) {
      classUtilitites.cloneElementToArea('.elmToClone','area-input-clonned');
  }
}

// form switch
var KTBootstrapSwitch = function() {

    // Private functions
    var demos = function() {
        // minimum setup
        $('[data-switch=true]').bootstrapSwitch();
    };

    return {
        // public functions
        init: function() {
        demos();
        },
    };
}();

KTBootstrapSwitch.init();
